// Agent panel:

// {{{ Office.QueueControlPanel

GW.define('Office.QueueControlPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'queue-control-panel js-msgbus',
			children: [{
				ref: 'wrapEl',
				className: 'wrap',
				children: [{
					ref: 'listEl',
					className: 'queue-list',
					'on:click': ev => {
						let btn = ev.target.closest('.queue');
						if (btn) {
							ev.preventDefault();
							this.onQueueButtonClick(btn, ev);
						}
					},
				}, {
					ref: 'controlsEl',
					className: 'controls',
					children: [{
						ref: 'expanderButton',
						xtype: 'Widgets.ExpanderToggleButton',
					}, {
						ref: 'subMenu',
						nodeName: 'button',
						className: 'more transparent hidden',
						children: [Utils.useIcon('vdots')],
						'on:click': ev => {
							ev.preventDefault();
							this.onMoreButtonClick(ev);
						},
					}, {
						ref: 'pauseButton',
						nodeName: 'button',
						className: 'pause hidden',
						'on:click': ev => {
							ev.preventDefault();
							this.onPauseButtonClick(ev);
						},
					}, {
						ref: 'extenPauseButton',
						nodeNname: 'button',
						className: 'pause hidden',
						title: _('Prodloužit autopauzu'),
						children: [Utils.useIcon('clockplus')],
						'on:click': ev => {
							ev.preventDefault();
							this.onExtendPauseButtonClick(ev);
						},
					}],
				}],
			}],
		}, this);

		this.queuesExpander = Features.expandingListContainer({
			container: this.listEl,
			expanderButton: this.expanderButton,
			onExpanded: expanded => {
				this.el.classList.toggle('expanded', expanded);
			},
		});

		this.redrawQueues();
	},

	releaseComponent() {
		this.queuesExpander.destroy();
	},

	async onQueueButtonClick(btn, ev) {
		let extension = Application.session.user.extension;
		let queue = btn.$data;
		if (queue.static) {
			return;
		}

		if (queue.state == 'unsubscribed') {
			await Office.QueueManager.joinQueue(queue.queue, extension);
		} else {
			await Office.QueueManager.leaveQueue(queue.queue, extension);
		}

		this.queuesExpander.expanded = false;
	},
	
	async onPauseButtonClick(ev) {
		let extension = Application.session.user.extension;
		if (!extension) {
			return;
		}

		let pause = Office.QueueManager.active_pause;
		if (pause) {
			await Office.QueueManager.unpauseExtension(extension);
		} else {
			let types = Office.QueueManager.getPauseTypes();
			if (types.length > 0) {
				let popup = new PopupMenu({
					options: types.map(pause_type => ({
						text: pause_type.name,
						async handle() {
							await Office.QueueManager.pauseExtension(extension, pause_type.id);
						},
					})),
				});
				
				PopupManager.show(popup, {
					anchorEl: ev.target.closest('button'),
					forceAxis: 'vertical',
					preferReadingOrder: true,
				});
			} else {
				await Office.QueueManager.pauseExtension(extension);
			}
		}
	},
	
	async onExtendPauseButtonClick(ev) {
		let extension = Application.session.user.extension;

		await Office.QueueManager.extendExtensionPause(extension);
	},

	getQueueListConfig() {
		let defaults = {
			show_queue_numbers: true,
			show_queue_names: true,
			compact: false,
			sort: 'number',
			subscribed_first: false,
		};

		let conf = JSON.parse(localStorage.getItem('agent-queue-list-config'));
		if (typeof conf != 'object' || !conf) {
			return defaults;
		}

		conf = Object.assign(defaults, conf);

		if (!conf.compact) {
			conf.show_queue_numbers = conf.show_queue_names = true;
		} else if (conf.show_queue_numbers && conf.show_queue_names) {
			conf.show_queue_numbers = false;
		} else if (!conf.show_queue_names && !conf.show_queue_numbers) {
			conf.show_queue_names = true;
		}

		return conf;
	},

	saveQueueListConfig(conf) {
		localStorage.setItem('agent-queue-list-config', JSON.stringify(conf));
	},

	updateQueueListConfig(patch) {
		this.saveQueueListConfig(Object.assign(this.getQueueListConfig(), patch));

		this.redrawQueues();
	},

	onMoreButtonClick(ev) {
		let extension = Application.session.user.extension;
		let conf = this.getQueueListConfig();

		let popup = new PopupMenu({
			options: [{
				iconName: 'login',
				text: _('Přihlásit do všech front'),
				async handle() {
					await Office.QueueManager.joinAllQueues(extension);
				},
			}, {
				iconName: 'logout',
				text: _('Odhlásit ze všech front'),
				async handle() {
					await Office.QueueManager.leaveAllQueues(extension);
				},
			}, {
				hidden: !conf.compact,
				render: {
					className: 'option separator',
				}
			}, {
				hidden: !conf.compact,
				iconName: 'number',
				text: _('Zobrazit čísla front'),
				cls: conf.show_queue_numbers ? 'active' : undefined,
				rightIconName: conf.show_queue_numbers ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						show_queue_numbers: !conf.show_queue_numbers,
						show_queue_names: !!conf.show_queue_numbers,
					});
				},
			}, {
				hidden: !conf.compact,
				iconName: 'letter',
				text: _('Zobrazit názvy front'),
				cls: conf.show_queue_names ? 'active' : undefined,
				rightIconName: conf.show_queue_names ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						show_queue_names: !conf.show_queue_names,
						show_queue_numbers: !!conf.show_queue_names,
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: 'sorting',
				text: _('Řadit podle čísla front'),
				cls: conf.sort == 'number' ? 'active' : undefined,
				rightIconName: conf.sort == 'number' ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						sort: 'number',
					});
				},
			}, {
				iconName: 'sorting',
				text: _('Řadit podle názvu front'),
				cls: conf.sort == 'name' ? 'active' : undefined,
				rightIconName: conf.sort == 'name' ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						sort: 'name',
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: 'dashboard',
				text: _('Výrazné zobrazení front'),
				cls: !conf.compact ? 'active' : undefined,
				rightIconName: !conf.compact ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						compact: false,
					});
				},
			}, {
				iconName: 'hamburger',
				text: _('Kompaktní zobrazení front'),
				cls: conf.compact ? 'active' : undefined,
				rightIconName: conf.compact ? 'check' : null,
				handle: () => {
					this.updateQueueListConfig({
						compact: true,
					});
				},
			}, {
				render: {
					className: 'option separator',
				}
			}, {
				iconName: conf.subscribed_first ? 'checkbox-on' : 'checkbox-off',
				text: _('Zobrazovat přihlášené fronty jako první'),
				handle: () => {
					this.updateQueueListConfig({
						subscribed_first: !conf.subscribed_first,
					});
				},
			}],
		});

		PopupManager.show(popup, {
			anchorEl: ev.target,
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},
	
	updatePauseTimer() {
		let pause = Office.QueueManager.active_pause;

		if (!this.pauseTimer) {
			return;
		}

		if (!pause || !pause.start_ts) {
			this.pauseTimer.textContent = '';
			return;
		}

		const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts); 

		this.pauseTimer.textContent = Formats.duration_unpadded(Math.max(0, duration));
	},

	refreshPauseButton() {
		let pause = Office.QueueManager.active_pause;
		let is_subscribed = Office.QueueManager.getSubscribedQueues().length > 0;

		if (pause) {
			let is_wrapup = pause.end_ts && pause.type === 'wrapup';
			let pauseText = pause.pause_type ? (' (' + pause.pause_type.name + ')') : '';
			let actionText = {
				'wrapup': _('Zrušit autopauzu'),
				'autopause': _('Zrušit vynucenou pauzu'),
			}[pause.type] || _('Zrušit pauzu')

			this.pauseButton.gwReplaceChildren([{
				className: 'icon-wrap',
				children: [Utils.useIcon('play')],
			}, {
				className: 'info',
				children: [{
					className: 'text',
					children: [{
						nodeName: 'span',
						textContent: actionText,
					}, {
						nodeName: 'span',
						className: 'pause-type',
						':skip': !pause.pause_type,
						textContent: pauseText,
					}],
				}, {
					className: 'timer',
					ref: 'pauseTimer',
				}]
			}], this);

			this.extenPauseButton.classList.toggle('hidden', !is_wrapup);

			this.pauseButton.disabled = false;
			this.pauseButton.dataset.state = 'paused';
			this.pauseButton.$title = actionText + ' ' + pauseText;

			this.updatePauseTimer();
			Utils.interval(this, 'pause-timer-update', 1000, () => this.updatePauseTimer());
		} else {
			this.pauseButton.gwReplaceChildren([{
				className: 'icon-wrap',
				children: [Utils.useIcon('pause')],
			}, {
				className: 'info',
				children: [{
					className: 'text',
					textContent: _('Zapnout pauzu'),
				}, {
					className: 'timer',
					ref: 'pauseTimer',
				}]
			}]);

			this.extenPauseButton.classList.toggle('hidden', true);

			this.pauseButton.dataset.state = 'not-paused';
			this.pauseButton.disabled = !is_subscribed;
			this.pauseButton.$title = _('Zapnout pauzu');

			Utils.abortInterval(this, 'pause-timer-update');
		}

		let conf = this.getQueueListConfig();

		this.pauseButton.title = conf.compact ? this.pauseButton.$title || '' : '';
	},

	redrawQueues() {
		let conf = this.getQueueListConfig();
                let queues = Office.QueueManager.queues.slice();
		let extension = Application.session.user.extension;
		let showMenuAndPause = queues.length > 0 && extension;

		if (conf.sort == 'name') {
			queues.sort((a, b) => {
				let an = a.name || '';
				let bn = b.name || '';

				return an.localeCompare(bn);
			});
		}

		if (conf.subscribed_first) {
			queues.sort((a, b) => {
				let as = a.state == 'subscribed' ? 1 : 0;
				let bs = b.state == 'subscribed' ? 1 : 0;

				return bs - as;
			});
		}

		this.el.classList.toggle('compact', !!conf.compact);

		if (env.FEATURE_FLAGS.emailAndSms) {
			// add dummy queues for email and SMS
			queues = [
				{
					state: 'subscribed',
					name: 'Info',
					queue: 'info@evlicorp.com',
					type: 'email',
				},
				{
					state: 'subscribed',
					name: 'Název fronty',
					queue: '+420 777 888 991',
					type: 'sms',
				},
				...queues,
			];
		}
		
		if (queues.length == 0) {
			this.pauseButton.gwHide(true);
			this.subMenu.gwHide(true);
			this.listEl.gwReplaceChildren([{
				className: 'empty panel-container',
				textContent: _('Žádné fronty nejsou dostupné'),
			}]);
			return;
		}

		this.pauseButton.gwHide(!showMenuAndPause);
		this.pauseButton.title = conf.compact ? this.pauseButton.$title || '' : '';
		this.refreshPauseButton();

		this.subMenu.gwHide(!showMenuAndPause);

		this.listEl.gwReplaceChildren(queues.map(q => {
			const info = q.info;
			return {
				$data: q,
				nodeName: 'button',
				className: 'queue' + (!q.state ? ' disabled' : ''),
				'attr:data-status': q.state || 'unsubscribed', // unsubscribed subscribed paused
				'attr:data-static': q.static ? '1' : '0',
				'attr:data-type': q.type,
				children: [{
					className: 'status',
				}, {
					className: 'info',
					children: [{
						className: 'name',
						textContent: !conf.show_queue_names ? q.queue : q.name || q.queue,
						title: q.name || '',
					}, {
						':skip': !conf.show_queue_numbers || !q.name || !conf.show_queue_names,
						className: 'number',
						textContent: q.queue,
					}],
				}, {
					className: 'counts',
					children: info && [{
						':skip': info.free_agents_bad_max == null || info.free_agents_warn_max == null,
						className: 'free-agents button small static ' + 
							(info.free_agents_count <= info.free_agents_bad_max ? 'error' : 
								(info.free_agents_count <= info.free_agents_warn_max ? 'warning-secondary' : 'success-secondary')
							),
						textContent: info.free_agents_count,
						title: `${_('Volných agentů')} (${info.free_agents_count})`,
					}, {
						':skip': info.waiting_calls_warn_max == null || info.waiting_calls_ok_max == null,
						className: 'waiting-calls button small static ' +
							(info.waiting_calls_count <= info.waiting_calls_ok_max ? 'success-secondary' : 
								(info.waiting_calls_count <= info.waiting_calls_warn_max ? 'warning-secondary' : 'error')
							),
						textContent: info.waiting_calls_count,
						title: `${_('Čekajících hovorů')} (${info.waiting_calls_count})`,
					}]
				}],
			};
		}));

		this.queuesExpander.refresh();
	},

	onBusMessage(msg) {
		if (msg.type === 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.redrawQueues();
		}

		if (msg.type === 'QUEUE_MANAGER_PAUSE_TYPES_CHANGE') {
			if (this.pauseButton) {
				this.pauseButton.classList.toggle('with-pause-types', Office.QueueManager.getPauseTypes().length > 0);
			}
		}
	},
});

// }}}
// {{{ Office.AgentHistoryPanel

GW.define('Office.AgentHistoryPanel', 'Office.HistoryPanel', {
	getTabs() {
		return [{
			id: 'all',
			title: _('Všechny'),
			query: {
				queue: '*',
			},
		}, ...Office.QueueManager.queues.map(v => {
			return {
				id: 'queue-' + v.queue,
				title: v.queue + (v.name ? ` - ${v.name}` : ''),
				query: {
					queue: v.queue,
				},
			};
		})];
	},

	getApiQuery() {
		if (Application.getActiveUserGroup().options.queue_history_limited) {
			return {
				user_id: Application.session.user.id,
			};
		}

		return {};
	},

	async showCategoryDialog(call) {
		let me = this;
		let hierarchy;
		try {
			hierarchy = await Office.QueueManager.getCategoryHierarchy(call.last_queue);
		} catch (ex) {
			if (ex.status == 404) {
				Application.notify({
					kind: 'warning',
					text: _('Fronta {queue} nemá přiřazenu skupinu kategorií.')
						.replace('{queue}', call.queue),
				});
				return;
			}

			throw ex;
		}

		let dlg = new CDR.CallCategoryDialog({
			hierarchy,

			async onSave(data) {
				await REST.PUT('call-info/' + encodeURIComponent(call.id), data);
			},
		});

		dlg.setFormFieldsData({
			category: call.call_category || [],
		});
	},

	async showCallCard(call) {
		const call_data = {
			call_id: call.id,
			phone: call.caller && call.caller.number,
		};

		// preload the data before showing the dialog to avoid UI flicker
		let data = await REST.GET('call-info/' + encodeURIComponent(call_data.call_id), {phone: call_data.phone});
		
		new Main.Dialog({
			title: _('Poznámky k hovoru'),

			'after:initComponent'() {
				let dlg = this;
				this.bodyEl.gwCreateChild({
					xtype: 'Office.CallPanel.CallCard',
					showCategory: false,
					showRightPane: false,
					call: call_data,
					'after:initComponent'() {
						this.setData(data);
					},
					'on:close'() {
						dlg.close();
					}
				});
			},
		});
	},

	async showRecordings(call) {
		let recordings = await REST.GET('calls/' + call.id + '/recordings');

		let dlg = new CDR.CallRecordingsDialog({
			recordingsBaseUrl: API_BASE + 'calls/' + call.id + '/recordings/',
		});

		dlg.setRecordings(recordings);
	},

	getListComponentConfig() {
		let me = this;

		return {
			xtype: 'SmartTable',
			monitorOverflow: true,
			extraClass: 'cdr-smart-table js-msgbus',
			getColumns() {
				function renderParty(party) {
					if (!party) {
						return [];
					}

					let info = [party.name, party.company].filter(v => v).join(', ');
					let numberEl = document.gwCreateElement({
						className: 'number',
					});

					me.renderPhoneNumber(numberEl, party.number);

					return [numberEl, {
						':skip': !info,
						className: 'info',
						textContent: info,
					}];
				}

				return [{
					id: 'direction',
					name: '',
					formatCell(td, v, row) {
						td.gwCreateChild(Office.renderDirectionIcon(row));
					},
				}, {
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(renderParty(v));
					},
				}, {
					id: 'queue',
					name: _('Vstupní fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							':skip': !row.queue_name,
							textContent: row.queue_name,
							className: 'text-nowrap',
						}, {
							textContent: row.queue,
							className: row.queue_name ? 'text-sm' : '',
						}]);
					},
				}, {
					id: 'last_queue',
					name: _('Poslední fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							':skip': !row.last_queue_name,
							textContent: row.last_queue_name,
							className: 'text-nowrap',
						}, {
							textContent: row.last_queue,
							className: row.last_queue_name ? 'text-sm' : '',
						}]);
					},
				}, {
					id: 'callee',
					name: _('Vyzvedl'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(renderParty(v));
					},
				}, {
					id: 'last_callee',
					name: _('Poslední volaný'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(renderParty(v));
					},
				}, {
					id: 'ring_duration',
					format: 'duration',
					name: _('Délka vyzvánění'),
				}, {
					id: 'duration',
					format: 'duration',
					name: _('Délka hovoru'),
				}, {
					id: 'start',
					format: 'datetime',
					name: _('Datum'),
				}, {
					id: 'ctl',
					formatCell(td, v, row) {
						me.renderCallIcons(td, row);
					},
				}];
			},

			renderRow(tr, row) {
				tr.dataset.direction = row.direction || '';
				tr.dataset.result = row.result || '';
			},

			refreshControls() {
				for (let btn of this.el.querySelectorAll('button[data-action]')) {
					btn.disabled = !Office.CallManager.canDo(btn.dataset.action);
				}
			},

			onBusMessage(msg) {
				if (msg.type == 'CALL_MANAGER_CHANGE') {
					this.refreshControls();
				}
			},

			'after:setData'() {
				this.refreshControls();
			},
		};
	},

	/*
	 * PLUGIN: extension point
	 */
	renderCallIcons(td, call) {
		if (this.showDialButton()) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'success icon-only small',
				'attr:data-action': 'dial',
				title: _('Vytočit'),
				'on:click': ev => this.onDial(call, ev),
			});
		}
		
		td.gwCreateChild({
			nodeName: 'button',
			className: 'small secondary icon-only',
			children: [Utils.useIcon(call.has_notes ? 'documentwithcontentfilled' : 'document')],
			title: call.has_notes ? _('Zobrazit poznámky') : _('Přidat poznámku'),
			'on:click': ev => this.showCallCard(call),
		});

		if (call.last_queue_has_category_hierarchy && call.result == 'connected') {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				children: [Utils.useIcon(call.call_category ? 'categoryfilled' : 'categoryempty')], 
				title: call.call_category ? _('Zobrazit Kategorie') : _('Přidat Kategorie'),
				'on:click': ev => this.showCategoryDialog(call),
			});
		} else {
			// This button is used merely as a non-visual padding element
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only vhidden',
				disabled: true,
			});
		}

		if (call.has_recordings) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				children: [Utils.useIcon('dialingfilled')],
				title: call.recordings_readable ? _('Zobrazit nahrávky') : _('K nahrávkám nemáte přístup'),
				disabled: !call.recordings_readable,
				'on:click': ev => this.showRecordings(call),
			});
		} else {
			// This button is used merely as a non-visual padding element
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only vhidden',
				disabled: true,
			});
		}
	},
	
	showDialButton() {
		return true;
	},

	async onDial(call, ev) {
		let my_number = Application.session.user.extension;
		let is_forwarded = call.last_callee && call.last_callee.number != call.callee.number;
		let peers = [call.caller];
		if (call.caller.number == my_number) {
			peers = [call.callee];

			if (is_forwarded) {
				peers.push(call.last_callee);
			}
		} else if (is_forwarded && call.last_callee.number == my_number) {
			peers.push(call.callee);
		}

		let number = (await Office.CallManager.selectContact(ev, peers)).number;
		
		number = await Office.QueueManager.makeQueueAssignmentNumber(call.queue, number);

		Office.CallManager.doAction({action: 'dial', number});
	},

	'after:onBusMessage'(msg) {
		if (msg.type == 'CDR_NOTE_ADDED' || msg.type == 'CALL_INFO_CHANGED') {
			if (this.hasCallLoaded(msg.call_id)) {
				// reload data after cdr note or call info
				// change reported by the backend
				Utils.clearCache(this);
				this.reload();
			}
		}

		if (msg.type == 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			/*
			 * We need to update the list of queues (tabs)
			 */
			this.reload();
		}
	},
});

// }}}

// Call panel:

// {{{ Office.CallPanel

GW.define('Office.CallPanel', 'GW.Component', {

	autoOpenedCalls: new Set(),
	userInteractedCalls: new Set(),
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'tabsEl',
				xtype: 'Widgets.ButtonSwitcher',
				cls: "button-switcher separate",
				renderItem: i => ({
					$data: i,
					'attr:data-item-id': i.id,
					nodeName: 'button',
					className: 'item',
					href: i.href || '#',
					children: [{
						nodeName: 'span',
						className: 'title',
						textContent: i.title,
					}, {
						':skip': i.preventClose || !i.onClose,
						nodeName: 'span',
						className: 'icon-wrapper',
						children: [Utils.useIcon('cross')],
						'on:click': ev => {
							ev.preventDefault();
							i.onClose();
						},
					}],
				}),
				'on:beforeselect': (c, i) => {
					this.selectCall(i.id);
				},
			}, {
				ref: 'cardSwitcher',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		this.openCalls = this.loadCalls();
	},

	selectCall(id) {
		Application.route({
			paramsFn: params => {
				if (id === 'active') {
					// override 'active' with actual active call id
					let active_call = Office.CallManager.getActiveCall();
					if (active_call && this.openCalls.some(call => call.call_id == active_call.call_id)) {
						id = active_call.call_id;
					}
				}
				
				if (id === 'active' || !id) {
					params.delete('call_id');
				} else {
					params.set('call_id', id);
				}

				return params;
			},
		});
	},

	/*
	 * Open call list management. Open calls are calls the user loaded call
	 * card for.
	 */

	loadCalls() {
		let calls = localStorage.getItem('call-panel-cards-' + Application.session.user.id);
		let list = calls ? JSON.parse(calls) : [];

		/*
		 * We had a bug where we could have saved cards for calls without call_id,
		 * which causes problems. Remove these calls on load.
		 */
		list = list.filter(c => c.call_id);
		list = list.slice(0, 100); // ensure max ~100 calls can be open

		return list;
	},

	saveCalls() {
		localStorage.setItem('call-panel-cards-' + Application.session.user.id, JSON.stringify(this.openCalls));
	},

	addCall(call) {
		if (this.openCalls.some(c => c.call_id === call.call_id)) {
			return;
		}

		this.openCalls.unshift(call);
		this.saveCalls();
	},
	
	modifyCall(call_id, func) {
		let call = this.openCalls.find(c => c.call_id == call_id);
		if (call) {
			func(call);
			this.saveCalls();
		}
	},

	removeCall(call_id) {
		this.openCalls = this.openCalls.filter(c => c.call_id !== call_id);
		this.saveCalls();
	},

	openActiveCall(mode = 'user') {
		let call = Office.CallManager.getActiveCall();
		if (!call || !call.peer) {
			return;
		}

		this.addCall({
			call_id: call.call_id,
			phone: call.peer.number,
			queue: call.queue,
		});
		let select = mode == 'user';

		if (mode == 'auto' && Application.getActiveUserGroup().options.call_card_switch_to_on_open) {
			Application.dispatchMessage({type: 'SWITCH_TO_CALL_PANEL'});
			select = true;
		}
		
		if (!select && !(new URLSearchParams(location.search).has('call_id'))) {
			// call is not to be selected, but selected active card is 
			// the first one with active call -> force select this call id 
			// to update URI and refresh the UI 
			select = true;
		}

		if (select) {
			this.selectCall(call.call_id);
		} else {
			// do not refresh all UI, just the tabs to add close button in new call card
			this.refreshTabs();
		}
	},

	/*
	 * Show tabs such that the first tab selects either the no-call or
	 * ongoing call screens, or the actual call card, depending on:
	 *
	 * - active call status from call manager
	 * - whether the call is already in openCalls or not
	 *
	 * Rest of the buttons are for other already open call cards from the
	 * past. (based on this.openCalls which is persisted across page reloads)
	 */
	refreshTabs() {
		let dialer_call = Office.CallManager.getActiveCall();
		let is_active_call_open = dialer_call && this.openCalls.some(c => c.call_id == dialer_call.call_id);
		let tabs = [];
		
		let translatedCallStatus;
		switch(dialer_call && dialer_call.status) {
			case 'dialing': translatedCallStatus = _('Vytáčený hovor'); break;
			case 'incomming': translatedCallStatus = _('Příchozí hovor'); break;
			case 'hold': translatedCallStatus = _('Podržený hovor'); break;
			case 'connected': translatedCallStatus = _('Probíhající hovor'); break;
			default: translatedCallStatus = _('Žádný aktivní hovor');
		}

		tabs.push({
			id: 'active',
			call_id: dialer_call && dialer_call.call_id,
			title: translatedCallStatus,
			preventClose: !is_active_call_open,
			onClose: () => {
				this.removeCall(dialer_call.call_id);
				this.selectCall('active');
			},
		});

		let prev_tab = 'active';
		for (let c of this.openCalls.filter(c => !dialer_call || c.call_id != dialer_call.call_id)) {
			let next_sel = prev_tab;

			tabs.push({
				id: c.call_id,
				title: c.phone,
				onClose: () => {
					this.removeCall(c.call_id);
					this.selectCall(next_sel);
				},
			});

			prev_tab = c.call_id;
		}
		
		let sel = this.tabsEl.getSelected();
		this.tabsEl.setItems(tabs);
		this.tabsEl.setSelected(sel);
	},

	/*
	 * This handles initial loads, changes in active call state, and
	 * activations of a call cards by the user. Goal is to show a proper
	 * tab buttons, select a correct tab, and load a correct card to
	 * cardSwitcher.
	 */
	async applyParams(params) {
		let selected_tab = 'active';
		let dialer_call = Office.CallManager.getActiveCall();
		let open_call = params.get('call_id');
		let me = this;

		/*
		 * Without peer set, don't offer the call in call cards.
		 */
		if (dialer_call && !dialer_call.peer) {
			dialer_call = null;
		}

		if (dialer_call) {
			// keep call status in the openCalls list
			this.modifyCall(dialer_call.call_id, call => call.status = dialer_call.status);
		} else {
			if (Application.getActiveUserGroup().options.call_card_close_on_end) {
				// remove auto opened call cards which user has not interacted with
				this.openCalls.forEach(call => {
					if (this.autoOpenedCalls.has(call.call_id) && !this.userInteractedCalls.has(call.call_id)) {
						// delete = allow auto reopening if the same call appears again (like repeated queue call)
						this.autoOpenedCalls.delete(call.call_id);
						this.userInteractedCalls.delete(call.call_id);

						this.removeCall(call.call_id);

						Performance.pushEvent({
							kind: 'call-card-auto-close',
							call_id: call.call_id,
						});
					}
				})
			}
		}

		this.refreshTabs();

		let call = this.openCalls.find(c => c.call_id == open_call);
		if (call) {
			let card = await this.cardSwitcher.show({
				id: call.call_id,
				xtype: 'Office.CallPanel.CallCard',
				call,
				'on*:change'() {
					me.userInteractedCalls.add(call.call_id);
				},
				'on:close'() {
					me.userInteractedCalls.add(call.call_id);
					me.tabsEl.getItems().filter(i => (i.call_id || i.id) == call.call_id).forEach(i => i.onClose());
				},
			});

			if (!dialer_call || call.call_id != dialer_call.call_id) {
				selected_tab = call.call_id;
			}

			if (dialer_call) {
				card.updateCallData(dialer_call);
			}
		} else if (dialer_call && ['dialing', 'incomming', 'hold', 'connected'].includes(dialer_call.status)) {
			this.cardSwitcher.show({
				id: `incoming-${dialer_call.status}`,
				xtype: 'Office.CallPanel.CallIncomming',
				callstatus: dialer_call.status,
				'on:loadrequested': c => this.openActiveCall('user'),
			});
		} else {
			this.cardSwitcher.show({
				id: 'no-call',
				xtype: 'Office.CallPanel.NoCall',
			});
		}

		this.tabsEl.setSelected(selected_tab);

		// cleanup closed cards
		for (let c of this.cardSwitcher.getCards()) {
			if (c instanceof Office.CallPanel.CallCard) {
				let call_is_open = this.openCalls.some(call => call.call_id == c.call.call_id);
				if (!call_is_open) {
					c.destroy();
				}
			}
		}

		if (dialer_call &&
			Application.getActiveUserGroup().options.call_card_open_on_ring &&
			(dialer_call.status == 'incomming' || dialer_call.status == 'dialing') &&
			!this.autoOpenedCalls.has(dialer_call.call_id) &&
			!this.userInteractedCalls.has(dialer_call.call_id) // do not auto opened if user interacted with the call card
		) {
			this.autoOpenedCalls.add(dialer_call.call_id);
			this.openActiveCall('auto');

			Performance.pushEvent({
				kind: 'call-card-auto-open',
				call_id: dialer_call.call_id,
			});
		}
	},
	
	onBusMessage(msg) {
		if (msg.type === 'CALL_MANAGER_CHANGE') {
			this.applyParams(new URLSearchParams(location.search));
		}

		if (msg.type == 'CALL_ENDED') {
			// delay auto removing - do not remove before DIALER_CHANGED event
			setTimeout(() => {
				this.autoOpenedCalls.delete(msg.call_id);
				this.userInteractedCalls.delete(msg.call_id);
			}, 1000);
		}
	},
});

// }}}
// {{{ Office.CallPanel.CategorySelector

GW.define('Office.CallPanel.CategorySelector', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'call-category-selector',
			children: [{
				ref: 'cat1',
				xtype: 'SelectField',
				filterable: true,
				placeholder: _('Vyberte kategorii'),
				label: _('Hlavní kategorie'),
				getOptions: () => this.getCategoryOptions(null),
				transformOption(o) {
					return {
						value: o.id,
						text: o.name,
						cat: o,
					};
				},
				'on:change': c => {
					this.refreshCategories();
					this.cat2.setValue(null);
					this.fire('change');
				},
			}, {
				ref: 'cat2',
				xtype: 'SelectField',
				filterable: true,
				placeholder: _('Vyberte podkategorii'),
				label: _('Podkategorie'),
				optional: true,
				transformOption(o) {
					return {
						value: o.id,
						text: o.name,
						cat: o,
					};
				},
				getOptions: () => this.cat1.getValue() ? this.getCategoryOptions(this.cat1.getValue()) : [],
				'on:change': c => {
					this.fire('change');
				},
			}],
		}, this);

		this.setCategoryList([]);
	},

	setVisible(v) {
		this.el.gwHide(!v);
	},

	getCategoryOptions(parent) {
		let cats = this.categories.filter(c => c.parent == parent).map(c => {
			return {
				value: c.id,
				text: c.name,
				cat: c,
			};
		});

		cats.unshift({
			value: null,
			text: '-----',
		});

		return cats;
	},

	refreshCategories() {
		let l1_val = this.cat1.getValue();
		let l2_empty = !l1_val || this.getCategoryOptions(l1_val).length == 0;

		this.cat2.setDisabled(l2_empty); 
	},

	setCategoryList(cats) {
		this.categories = cats || [];

		this.refreshCategories();
		this.setVisible(this.categories.length > 0);
	},

	getSelectedCategories() {
		let o1 = this.cat1.getSelectedOption();
		let o2 = this.cat2.getSelectedOption();

		if (o1 && o1.cat) {
			if (o2 && o2.cat) {
				return [o1 && o1.cat, o2 && o2.cat];
			}

			return [o1 && o1.cat];
		}

		return null;
	},

	getValue() {
		return this.cat2.getValue() || this.cat1.getValue();
	},

	setValue(cats) {
		if (cats == null || cats.length == 0) {
			this.cat1.setValue();
			this.refreshCategories();
			return;
		}

		if (cats[0]) {
			this.cat1.setValue(cats[0]);
		}

		if (cats[1]) {
			this.cat2.setValue(cats[1]);
			this.cat2.setDisabled(false); 
		} else {
			this.refreshCategories();
		}
	},
});

// }}}
// {{{ Office.CallPanel.NoCall

GW.define('Office.CallPanel.NoCall', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'incomming-container',
			children: [{
				className: 'title text-muted',
				textContent: _('Žádný aktivní hovor'),
			}],
		});
	},
});

// }}}
// {{{ Office.CallPanel.CallIncomming

GW.define('Office.CallPanel.CallIncomming', 'GW.Component', {
	initComponent() {
		let translatedCallStatus;
		switch(this.callstatus) {
			case 'dialing': translatedCallStatus = _('Vytáčíte nový hovor'); break;
			case 'incomming': translatedCallStatus = _('Máte příchozí hovor'); break; 
			case 'hold': translatedCallStatus = _('Máte podržený hovor'); break; 
			case 'connected': translatedCallStatus = _('Máte probíhající hovor'); break; 
			default: translatedCallStatus = '';
		}
		
		this.el = document.gwCreateElement({
			children: [{
				className: 'incomming-container',
				children: [{
					className: 'title',
					textContent: translatedCallStatus,
				}, {
					nodeName: 'button',
					className: 'primary',
					textContent: _('Načíst kartu hovoru'),
					'on:click': () => {
						this.fire('loadrequested');
					},
				}],
			}]
		}, this);
	},
});

// }}}
// {{{ Office.CallPanel.PhoneNumberHistory

GW.define('Office.CallPanel.PhoneNumberHistory', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			'on*:click': ev => {
				if (ev.target.closest('.expander')) {
					ev.target.closest('.history-item-content').classList.toggle('expanded');
				}
			},
		}, this);
	},

	getNoteExpandState() {
		return new Set(Array.from(this.el.querySelectorAll('.history-item-content.expanded'))
			.map(el => el.$data.id));
	},

	setNoteExpandState(state) {
		for (let el of this.el.querySelectorAll('.history-item-content')) {
			el.classList.toggle('expanded', state.has(el.$data.id));
		}
	},

	renderItem(call, exclude_number) {
		let route = [{
			number: call.number,
			name: call.queue_name,
		}, call.caller, call.callee];

		if (call.callee.number != call.last_callee.number) {
			route.push(call.last_callee);
		}

		route = route.filter(r => r && r.number && !phone_number_equal(r.number, exclude_number));

		let detail = route.map(r => {
			return [r.number, r.name, r.company].filter(v => v).join(' ');
		}).join(' - ');

		let time = Formats.date(call.start) + ', ' + Formats.time(call.start);
		if (call.duration) {
			time += ', ' + Formats.duration(call.duration);
		}

		let category = null;
		if (call.call_category && call.call_category.length > 0) {
			let hierarchy = call.call_category_hierarchy;

			category = {
				className: 'history-item-call-categories',
				children: [_('Kategorie'), {
					className: 'hierarchy',
					textContent: " - " + hierarchy.name,
				}, ...call.call_category.map(c => {
					return {
						className: 'category',
						textContent: c.name,
					};
				})],
			};
		}

		return {
			className: 'history-item',
			children: [{
				className: 'history-item-header',
				children: [{
					className: 'history-item-header-icon',
					children: [Office.renderDirectionIcon(call)],
				}, {
					className: 'history-item-header-info',
					children: [{
						className: 'history-item-header-datetime',
						textContent: time,
					}, {
						':skip': !detail,
						className: 'history-item-header-detail',
						textContent: detail,
					}],
				}],
			}, category, {
				$data: call,
				className: 'history-item-content',
				children: call.notes.map(n => this.renderCallNote(n)).concat([{
					':skip': call.notes.length <= 1,
					className: 'expander',
					children: [{
						textContent: _('Více'),
						className: 'label expand',
					}, {
						textContent: _('Méně'),
						className: 'label collapse',
					}],
				}]),
			}],
		};
	},

	renderCallNote(note) {
		return {
			className: 'call-info-agent-note-box',
			children: [{
				className: 'header',
				children: [{
					className: 'user',
					textContent: note.user_name + ' - ' + note.user_extension,
				}, {
					className: 'time',
					textContent: Formats.datetime(note.ts),
				}],
			}, {
				className: 'content',
				textContent: note.note,
			}],
		};
	},

	showLoading() {
		this.el.gwReplaceChildren([{
			className: 'empty',
			textContent: _('Data se načítají...'),
		}]);
	},

	setData(calls, exclude_number) {
		let state = this.getNoteExpandState();

		if (calls.length > 0) {
			this.el.gwReplaceChildren(calls.map(c => this.renderItem(c, exclude_number)));
		} else {
			this.el.gwReplaceChildren([{
				className: 'empty',
				textContent: _('Číslo nemá historii'),
			}]);
		}

		this.setNoteExpandState(state);
	},
});

// }}}
// {{{ Office.CallPanel.CallCard

GW.define('Office.CallPanel.CallCard', 'GW.Component', {
	call: null,
	showCategory: true,
	showRightPane: true,
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'contactEl',
				className: 'contact-container',
			}, {
				className: 'content-container',
				children: [{
					ref: 'noteContainer',
					className: 'note-container',
					children: this.renderLeftPane(),
				}, {
					':skip': !this.showRightPane,
					ref: 'rightPaneEl',
					className: 'right-pane-container',
					children: [{
						ref: 'rightPaneTabsEl',
						xtype: 'Widgets.ButtonSwitcher',
						cls: "button-switcher small",
						'on:beforeselect': (c, i) => {
							this.showRightPaneTab(i.id);
						},
					}, {
						ref: 'rightPaneTitle',
						className: 'call-card-title',
					}, {
						ref: 'rightPaneCardsEl',
						xtype: 'Widgets.CardSwitcher',
					}],
				}],
			}]
		}, this);

		Features.horizontalSplitResizerMixin({
			storageKey: 'note-container-ratio',
			leftEl: this.noteContainer,
			lifetimeComponent: this,
		});

		if (this.showRightPane) {
			let tabs = this.getRightPaneTabs().filter(t => t);
			if (tabs.length > 0) {
				if (tabs.length == 1) {
					// show only one card, with title, hide tabs
					this.rightPaneTitle.textContent = tabs[0].title;
					this.rightPaneTabsEl.el.classList.add('hidden');
				} else {
					this.rightPaneTitle.remove();
				}
				this.rightPaneTabsEl.setItems(tabs);
				this.showRightPaneTab(tabs[0].id);
			}
		}

		this.reloadOnActivate = true;
		this.firstLoadDone = false;
	},

	renderLeftPane() {
		let details = this.renderCallDetails();
		if (details.length > 0) {
			details.unshift({
				className: 'call-card-title',
				textContent: _('Detaily hovoru'),
			});
		}

		return [
			...details,
			...this.renderCategorySelector(),
			...this.renderCallNotes(),
		];
	},

	/*
	 * PLUGIN: extension point
	 */
	renderCallDetails() {
		return [];
	},

	renderCategorySelector() {
		return [{
			':skip': !this.showCategory,
			ref: 'categoryHierarchyNameEl',
			className: 'call-card-title hidden',
		}, {
			':skip': !this.showCategory,
			ref: 'categorySelector',
			xtype: 'Office.CallPanel.CategorySelector',
			'on:change': async c => {
				await REST.PUT('call-info/' + encodeURIComponent(this.call.call_id), {
					category: c.getValue(),
				});
			},
		}];
	},

	renderCallNotes() {
		return [{
			ref: 'notesTitleEl',
			className: 'call-card-title',
			textContent: _('Poznámky k hovoru'),
		}, {
			nodeName: 'label',
			textContent: _('Nová poznámka'),
		}, {
			ref: 'noteField',
			xtype: 'TextareaField',
			$key_Ctrl_Enter: () => {
				this.onSaveNote().then(() => {
					this.fire('close');
				});
			},
		}, {
			// PLUGIN: extension point for
			// adding more buttons
			ref: 'callNoteButtons',
			className: 'buttons',
			children: [{
				ref: 'sendButton',
				nodeName: 'button',
				type: 'button',
				className: 'primary',
				textContent: _('Uložit a zavřít kartu hovoru'),
				'on:click': ev => {
					this.onSaveNote().then(() => {
						this.fire('close');
					});
				},
			}],
		}, {
			ref: 'callNotesEl',
			className: 'note-list',
			'attr:text-no-entry': _('Tento hovor je bez poznámek'),
		}];
	},
	
	/*
	 * PLUGIN: extension point for plugins
	 */
	getRightPaneTabs() {
		return [{
			id: 'phone-history',
			title:  _('Historie čísla'),
			card: this.renderPhoneHistory(),
		}];
	},
	
	showRightPaneTab(id) {
		this.rightPaneTabsEl.setSelected(id);
		let tabs = this.rightPaneTabsEl.getItems();
		let tab = tabs.find(t => t.id == id);
		this.rightPaneCardsEl.show({
			id,
			...tab.card,
		});
	},
	
	renderPhoneHistory() {
		const call = this.call;
		
		return {
			xtype: 'Office.CallPanel.PhoneNumberHistory',
			async applyParams() {
				let signal = Utils.abortAndRetry(this, 'reload-history');

				if (!this.notFirstLoad) {
					this.showLoading();
					this.notFirstLoad = true
				}

				let calls = await REST.GET('calls', {
					extension: call.phone,
					include_notes: true,
					limit: 100,
				}, {signal});

				calls = calls.filter(c => c.id != call.call_id);

				this.setData(calls, call.phone);
			},
		};
	},

	async onSaveNote() {
		const note = this.noteField.getValue();
		if (!note) {
			return false;
		}

		try {
			this.noteField.setDisabled(true);
			this.sendButton.disabled = true;

			await REST.POST('call-info/' + this.call.call_id + '/notes', {note});

			this.noteField.setValue('');
			this.afterNoteSaved();
			return true;
		} finally {
			this.noteField.setDisabled(false);
			this.sendButton.disabled = false;
		}

		return false;
	},

	afterNoteSaved() {
		
	},

	renderCallNote: Office.CallPanel.PhoneNumberHistory.prototype.renderCallNote,

	async updateEditContactButton(contact) {
		const signal = Utils.abortAndRetry(this, 'contact-groups');
		const [groups] = await Utils.cache(this, 'contact-groups', 10000, REST.GET, 'contact-groups', null, {signal});

		const editableGroups = groups.filter(g => g.editable);
		if (!editableGroups.length) {
			return;
		}
		
		const phone = this.call.phone;
		
		if (await Office.InternalNumbers.isInternal(phone)) {
			// internal number do not need to be added in contacts
			return;
		}

		let contact_data = {
			phones: [phone],
		};
		if (contact) {
			if (contact.group_id) {
				// the contact has been just created, assume we have all fields set
				contact_data = contact;
			} else {
				contact_data = await REST.GET('contacts/' + contact.contact_id);
			}
			if (!editableGroups.some(g => g.group_id = contact_data.group_id)) {
				// the contact group is not editable = contact is not editable
				return;
			}
		}

		this.editContactBtn.onclick = async () => {
			new Office.ContactEditDialog({
				contactGroups: editableGroups,
				showDeleteButton: false,
				disabledFields: ['phone0', 'phone1'],
				title: contact ? _('Úprava kontaktu') : _('Nový kontakt'),
				contact: contact ? contact_data : {
					// if contact set, use its loaded data, else fill the only known data = phone
					phones: [phone],
				},
				'on:aftersave': (c,d) => this.setDataContact({...contact, ...d, contact_id: d.id})
			});
		}
		this.editContactBtn.classList.remove('hidden');
	},
	
	setDataContact(contact) {
		if (contact) {
			this.contactEl.gwReplaceChildren([Utils.useIcon('user'), {
				textContent: [contact.name, contact.company].filter(v => v).join(', ')
			}, {
				nodeName: 'button',
				ref: 'editContactBtn',
				title: _('Upravit kontakt'),
				className: 'small secondary icon-only hidden',
				children: [Utils.useIcon('edit')],
			}], this);
		} else {
			this.contactEl.gwReplaceChildren([{
				textContent: _('Kontakt není uložen v adresáři')
			}, {
				nodeName: 'button',
				ref: 'editContactBtn',
				title: _('Přidat do adresáře'),
				className: 'small secondary icon-only hidden',
				children: [Utils.useIcon('plus')],
			}], this);
		}
		this.updateEditContactButton(contact);
	},

	setData(data) {
		let {contact} = data;
		
		this.setDataContact(contact);

		if (data.call_notes.length > 0) {
			this.callNotesEl.gwReplaceChildren(data.call_notes.map(n => this.renderCallNote(n)));
		} else {
			this.callNotesEl.gwReplaceChildren([]);
		}

		if (this.showCategory) {
			this.categorySelector.setValue(data.call_category || []);
		}

		this.data = data;
	},

	/*
	 * In some situations we may receive queue information later on during
	 * the call. We need to update the UI with category info for that queue.
	 */
	async updateCallData(call) {
		if (this.call.queue || !call.queue) {
			return;
		}

		this.call.queue = call.queue;
		this.onQueueUpdated();
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async onQueueUpdated() {
		await this.reloadCategorySelector();
	},

	async reloadCategorySelector() {
		let signal = Utils.abortAndRetry(this, 'reload');
		
		if (this.showCategory && this.call.queue) {
			let hierarchy = await Office.QueueManager.getCategoryHierarchy(this.call.queue, {signal});

			this.categorySelector.setCategoryList(hierarchy ? hierarchy.categories : []);

			this.categoryHierarchyNameEl.gwHide(!hierarchy);
			this.categoryHierarchyNameEl.textContent = hierarchy ? _('Kategorie') + ' \u2014 ' + hierarchy.name : '';
			this.notesTitleEl.gwHide(!hierarchy);
		} else {
			this.notesTitleEl.gwHide(true);
		}
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async reload() {
		await this.reloadCategorySelector();
		await this.reloadCallInfo();
	},

	/*
	 * PLUGIN: extension point for loading more data
	 */
	async reloadCallInfo() {
		let signal = Utils.abortAndRetry(this, 'reload-call-info');

		let data = await REST.GET('call-info/' + encodeURIComponent(this.call.call_id), {phone: this.call.phone}, {signal});

		this.setData(data);
	},

	isCallRelated(call_id) {
		return this.call.call_id == call_id ||
			this.data.call_notes.some(n => n.call_id == call_id);
	},

	async applyParams() {
		if (this.reloadOnActivate) {
			this.reloadOnActivate = false;

			await this.reload();

			if (!this.firstLoadDone && this.call.queue) {
				this.firstLoadDone = true;

				await this.onQueueUpdated();
			}
		}
	},

	onBusMessage(msg) {
		if (msg.type === 'CDR_NOTE_ADDED' || msg.type === 'CALL_INFO_CHANGED') {
			if (this.isCallRelated(msg.call_id)) {
				if (this.el.offsetWidth) {
					this.reloadCallInfo();
				} else {
					this.reloadOnActivate = true;
				}
			}
		}
	},
});

// }}}

// Email/SMS:

// {{{ Office.DummyEmailPanel

GW.define('Office.DummyEmailPanel', 'GW.Component', {

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'tabsEl',
				xtype: 'Widgets.ButtonSwitcher',
				cls: "button-switcher separate",
				renderItem: i => ({
					$data: i,
					'attr:data-item-id': i.id,
					nodeName: 'button',
					className: 'item',
					children: [{
						nodeName: 'span',
						className: 'title',
						textContent: i.title,
					}],
				}),
				'on:beforeselect': (c, i) => {
					this.selectCard(i.id);
				},
			}, {
				ref: 'cardsEl',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);
	},
	

	redrawTabs() {

		const tabs = [{
			id: '1',
			title: 'mrsss@rattle.com',
		}, {
			id: '2',
			title: 'radovan.vata@gmail.com',
		}];


		this.tabsEl.setItems(tabs);

		this.tabsEl.setSelected(tabs[0].id);

		const selectedData = this.tabsEl.getSelectedItemData();

		this.cardsEl.show({
			id: selectedData.id,
			...this.renderCard(selectedData),
		});
	},

	renderCard(data) {
		// dummy data:
		const contact = {
			name: 'Petr Polívka',
			company: 'Korporát ABC',
		};
		const emailThread = {
			subject: 'Rozmotání klubka zmijí',
			messages: [{
				direction: 'received',
				from: 'mrsss@rattle.com',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'Dobrý den,\n' +
					'\n' +
					'chtěl bych se zeptat, jak rozmotat klubko zmijí.\n' +
					'\n' +
					'Děkuji za vaši dobrou radu\n' +
					'\n' +
					'Karel Haďák',
				attachments: [{
					name: 'ilustrace.png',
					iconData: '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',
				}, {
					name: 'prezentace.pdf',
				}, {
					name: 'readme.txt',
				}]
			}, {
				direction: 'sent',
				from: 'Jeffrey Lebowski',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'Statistics show that while 85 percent of the adult population in the US enjoys some type of gambling every year, between 2 and 3 percent.',
				attachments: [{
					name: 'hroznedlouhejnazev a pokracujeme.xlsx',
				}],
			}, {
				direction: 'received',
				from: 'mrsss@rattle.com',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'Statistics show that while 85 percent of the adult population in the US enjoys some type of gambling every year, between 2 and 3 percent.',
				attachments: [],
			}]
		};
		
		return {
			initComponent() {
				this.el = document.gwCreateElement({
					children: [{
						className: 'top-container',
						children: [{
							className: 'contact-container',
							children: [ Utils.useIcon('user'), {
									textContent: [contact.name, contact.company].filter(item => item).join(', ')
							}],
						}, {
							className: 'controls-container',
							children: [{
								nodeName: 'button',
								className: 'error',
								className: 'error',
								textContent: _('Uzavřít komunikaci'),
							}],
						}],
					}, {
						className: 'thread-content-container',
						children: [{
							className: 'call-card-title',
							textContent: emailThread.subject,
						}, {
							className: 'thread-container',
							children: emailThread.messages.map(msg => ({
								className: 'thread-message' + ` thread-message-${msg.direction}`,
								children: [{
									className: 'contact-icon',
									children: [Utils.useIcon('user')]
								}, {
									className: 'thread-content',
									children: [{
										className: 'message-header',
										children: [{
											className: 'message-from',
											textContent: msg.from,
											nodeName: 'span',
										}, {
											className: 'message-sent-at',
											textContent: Formats.datetime(msg.sent_ts),
											nodeName: 'span', 
										}],
									}, {
										className: 'message-text',
										textContent: msg.text,
									}, {
										className: 'message-attachments',
										children: msg.attachments.map(attachment => ({
											className: 'message-attachment',
											children: [{
												className: 'attachment-icon',
												style: attachment.iconData ? "background-image: url('data:image/png;base64," + attachment.iconData + "');" : '',
												children: [!attachment.iconData ? Utils.useIcon('document') : undefined],
											}, {
												className: 'attachment-metadata',
												children: [{
													className: 'attachment-name',
													textContent: attachment.name,
												}, {
													className: 'attachment-ext',
													textContent: attachment.name.split('.').pop(),
												}],
											}, {
												nodeName: 'button',
												type: 'button',
												className: 'transparent small icon-only',
												children: [Utils.useIcon('moreoptions')]
											}],
										})),
									}],
								}],
							})),
						}, {
							className: 'thread-create-message',
							children: [{
								nodeName: 'input',
								type: 'text',
								placeholder: 'Tož hoďte do placu nějaký ten hantec...',
							}, {
								nodeName: 'button',
								className: 'secondary icon-only',
								children: [Utils.useIcon('attachment')],
							}, {
								className: 'divider',
							}, {
								nodeName: 'button',
								className: 'primary icon-left',
								children: [
									Utils.useIcon('send'),
									{
										textContent: _('Odeslat'),
									}
								]
							}]
						}]
					}]
				})
			},
		}
	},

	applyParams(params) {
		this.redrawTabs();
	},

	reload() {
		this.applyParams(new URLSearchParams(location.search));
	},
});


// }}}
// {{{ Office.DummySmsPanel

GW.define('Office.DummySmsPanel', 'GW.Component', {

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'tabsEl',
				xtype: 'Widgets.ButtonSwitcher',
				cls: "button-switcher separate",
				renderItem: i => ({
					$data: i,
					'attr:data-item-id': i.id,
					nodeName: 'button',
					children: [{
						nodeName: 'span',
						className: 'title',
						textContent: i.title,
					}],
				}),
				'on:beforeselect': (c, i) => {
					this.selectCard(i.id);
				},
			}, {
				ref: 'cardsEl',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);
	},


	redrawTabs() {

		const tabs = [{
			id: '1',
			title: '+420 777 434 788',
		}, {
			id: '2',
			title: '+420 776 333 223',
		}];


		this.tabsEl.setItems(tabs);

		this.tabsEl.setSelected(tabs[0].id);

		const selectedData = this.tabsEl.getSelectedItemData();

		this.cardsEl.show({
			id: selectedData.id,
			...this.renderCard(selectedData),
		});
	},

	renderCard(data) {
		// dummy data:
		const contact = {
			name: 'Karel Haďák',
			company: 'Korporát ABC',
		};
		const smsThread = {
			messages: [{
				direction: 'received',
				from: '+420 777 434 788',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'chtěl bych se zeptat, jak rozmotat klubko zmijí, díky'
			}, {
				direction: 'sent',
				from: 'Jeffrey Lebowski',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'Statistics show that while 85 percent of the adult population in the US enjoys some type of gambling every year, between 2 and 3 percent.',
			}, {
				direction: 'received',
				from: '+420 777 434 788',
				sent_ts: (Date.now() / 1000) - 3600,
				text: 'Statistics show that while 85 percent of the adult population in the US enjoys some type of gambling every year, between 2 and 3 percent.',
			}]
		};

		return {
			initComponent() {
				this.el = document.gwCreateElement({
					children: [{
						className: 'top-container',
						children: [{
							className: 'contact-container',
							children: [ Utils.useIcon('user'), {
									textContent: [contact.name, contact.company].filter(item => item).join(', ')
							}]
						}, {
							className: 'controls-container',
							children: [{
								nodeName: 'button',
								className: 'error',
								className: 'error',
								textContent: _('Uzavřít komunikaci'),
							}],
						}],
					}, {
						className: 'thread-content-container',
						children: [{
							':skip': !smsThread.subject,
							className: 'call-card-title',
							textContent: smsThread.subject,
						}, {
							className: 'thread-container',
							children: smsThread.messages.map(msg => ({
								className: 'thread-message' + ` thread-message-${msg.direction}`,
								children: [{
									className: 'contact-icon',
									children: [Utils.useIcon('user')]
								}, {
									className: 'thread-content',
									children: [{
										className: 'message-header',
										children: [{
											className: 'message-from',
											textContent: msg.from,
											nodeName: 'span',
										}, {
											className: 'message-sent-at',
											textContent: Formats.datetime(msg.sent_ts),
											nodeName: 'span', 
										}],
									}, {
										className: 'message-text',
										textContent: msg.text,
									}],
								}],
							})),
						}, {
							className: 'thread-create-message',
							children: [{
								nodeName: 'input',
								type: 'text',
								placeholder: 'Tož hoďte do placu nějaký ten hantec...',
							}, {
								nodeName: 'button',
								className: 'primary icon-left',
								children: [
									Utils.useIcon('send'),
									{
										textContent: _('Odeslat'),
									}
								]
							}],
						}],
					}]
				})
			},
		}
	},

	applyParams(params) {
		this.redrawTabs();
	},

	reload() {
		this.applyParams(new URLSearchParams(location.search));
	},
});

// }}}

// Outbound:

// {{{ Office.AgentOutboundPanel

GW.define('Office.AgentOutboundPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: [{
						ref: 'tabs',
						xtype: 'Widgets.ButtonSwitcher',
						cls: "button-switcher small campaign-switcher",
						'on:beforeselect': (c, i) => {
							Application.route({
								paramsFn: params => {
									params.set('campaign', i.id);
									return params;
								},
							});
						},
					}, {
						ref: 'filter',
						xtype: 'SelectField',
						popupAutoWidth: false,
						cls: 'small',
						options: [{
							id: 'new',
							value: 'new',
							text: _('Nezahájené'),
							query: {
								status: 'new',
								limit_time: true,
								limit: 200,
							},
						}, {
							id: 'mine',
							value: 'mine',
							text: _('Moje případy'),
							query: {
								status: 'mine',
								limit_time: true,
								limit: 200,
							},
						}, {
							id: 'all',
							value: 'all',
							text: _('Všechny případy'),
							query: {
								status: 'not-closed',
								limit_time: false,
								limit: 200,
							},
						}],
						'on:change': c => {
							Application.route({
								paramsFn: params => {
									params.set('campaign_filter', c.getValue());
									return params;
								},
							});
						},
					}, {
						ref: 'descriptionButton',
						type: 'button',
						nodeName: 'button',
						className: 'secondary icon-left small show-description-button',
						children: [Utils.useIcon('report'), _('Popis kampaně') ],
						'on:click': () => {
							let description = this.description;
							new Main.Dialog({
								title: _('Popis kampaně'),

								'after:initComponent'() {
									this.bodyEl.gwCreateChild({
										textContent: description
									});
								},
							});
						},
					}],
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		Utils.interval(this, 'timer-update', 60000 + Math.random() * 20000, () => this.timedRefresh());
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},

	getListComponentConfig() {
		let me = this;

		return {
			xtype: 'SmartTable',
			monitorOverflow: true,
			extraClass: 'outbound-cases-smart-table js-msgbus',
			getColumns() {
				return [{
					id: 'contact_name',
					name: _('Jméno'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_name_linked;
					},
				}, {
					id: 'contact_company',
					name: _('Firma'),
					formatCell(td, v, row) {
						td.textContent = row.contact_name || row.contact_company ? v : row.contact_company_linked;
					},
				}, {
					id: 'contact_phone',
					name: _('Telefon'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'contact_note',
					name: _('Poznámka'),
					formatCell(td, v, row) {
						v = (v || '').trim();

						td.textContent = v.replace(/\r?\n/g, ' ⏎ ');
						td.title = v;
					},
				}, {
					id: 'status',
					name: _('Stav'),
					format: 'campaign_case_status',
				}, {
					id: 'activated',
					name: _('Čas zahájení'),
					format: 'datetime',
				}, {
					id: 'last_agent_name',
					name: _('Vyřizuje'),
				}, {
					id: 'last_agent_exten',
					name: _('Linka'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'attempts',
					name: _('Pokusů'),
				}, {
					id: 'last_contact',
					name: _('Čas posledního volání'),
					format: 'datetime',
				}, {
					id: 'time_slots',
					name: _('Časový slot'),
					formatCell(td, v, row) {
						/* let's keep it just here for
						 * now, because this is just
						 * a quirky API.
						 */
						function formatTime(t) {
							if (t == null || t === '') {
								return '';
							}

							let h = Math.floor(t / 60 / 60);
							let m = Math.floor(Math.floor(t / 60) % 60);

							return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0');
						}

						let start = formatTime(row.contact_time_range_start);
						let end = formatTime(row.contact_time_range_end);

						if (start || end) {
							td.textContent = `${start} - ${end}`;
						}
					},
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell(td, v, row) {
						td.gwCreateChild({
							nodeName: 'button',
							className: 'success icon-only small',
							'attr:data-action': 'dial',
							title: _('Vytočit'),
							'on:click': ev => {
								me.onDial(row);
							},
						});

						if (row.url != null && !String(row.url).match(/^[a-z0-9.+-]{1,30}:/i)) {
							row.url = null;
						}

						td.gwCreateChild({
							nodeName: 'a',
							className: 'outbound-case-openurl icon-only small button secondary' + (!row.url ? ' vhidden' : ''),
							href: row.url,
							target: '_blank',
							title: row.url && (_('Otevřít') + ' ' + row.url),
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'secondary icon-only small' + (row.has_notes ? ' filled' : ''),
							'attr:data-action': 'outbound-case-notes',
							title: _('Poznámky'),
							'on:click': ev => {
								ev.preventDefault();
								me.showNotesDialog(row);
							},
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'icon-only small ' + (row.close_result == 'success' ? 'primary selected' : 'secondary'),
							'attr:data-action': 'outbound-case-close',
							title: _('Uzavřít - úspěšné'),
							'on:click': ev => {
								ev.preventDefault();
								me.closeCase(row, 'success');
							},
						});

						td.gwCreateChild({
							nodeName: 'button',
							className: 'icon-only small ' + (row.close_result == 'fail' ? 'primary error selected' : 'secondary'),
							'attr:data-action': 'outbound-case-close-fail',
							title: _('Uzavřít - neuspěšné'),
							'on:click': ev => {
								ev.preventDefault();
								me.closeCase(row, 'fail');
							},
						});
					},
				}];
			},

			renderRow(tr, row) {
				tr.dataset.status = row.status || '';
				tr.dataset.mine = row.last_agent_user_id == Application.session.user.id ? '1' : '0';
				tr.classList.toggle('linked-contact', !(row.contact_name || row.contact_company)
					&& !!(row.contact_company_linked || row.contact_name_linked));
			},

			refreshControls() {
				for (let btn of this.el.querySelectorAll('button[data-action]')) {
					let action = btn.dataset.action;
					switch (action) {
					case 'outbound-case-notes':
						btn.disabled = false;
						break;
					case 'outbound-case-close':
					case 'outbound-case-close-fail':
						btn.disabled = false; //XXX: disable when other agent is working on this case
						break;
					default:
						btn.disabled = !Office.CallManager.canDo(action);
						break;
					}
				}
			},

			onBusMessage(msg) {
				if (msg.type == 'CALL_MANAGER_CHANGE') {
					this.refreshControls();
				}
			},

			'after:setData'() {
				this.refreshControls();
			},
		};
	},

	async closeCase(data, close_result) {
		await REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/close', {close_result});
		this.reload();
	},

	showNotesDialog(data) {
		new Main.NotesDialog({
			onSave(text) {
				return REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/comments', {
					text,
				});
			},

			loadData(signal) {
				return REST.GET('outbound/cases/' + encodeURIComponent(data.id) + '/comments', null, {signal});
			},
		});
	},

	async onDial(data) {
		await REST.POST('outbound/cases/' + encodeURIComponent(data.id) + '/activate');
		this.reload();

		let number = data.contact_phone;
		let campaign = this.tabs.getSelectedItemData();
		if (campaign && campaign.campaign && campaign.campaign.prefix_queue) {
			number = await Office.QueueManager.makeQueueAssignmentNumber(campaign.campaign.prefix_queue.queue, number);
		}

		Office.CallManager.doAction({action: 'dial', number, send_metadata: {outbound_case: data.id}});
	},

	reload() {
		Utils.clearCache(this);
		this.applyParams(new URLSearchParams(location.search));
	},

	getSelectedCampaign() {
		let tab = this.tabs.getSelectedItemData();

		return tab ? tab.campaign.id : null;
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');
		let [campaigns, campaignsChanged] = await Utils.cache(this, 'campaigns', 60000, REST.GET, 'outbound/campaigns', {
			status: 'active',
		}, {signal});

		let tabs = campaigns.map(c => {
			return {
				id: 'campaign-' + c.id,
				title: c.name,
				campaign: c,
			};
		});

		if (campaignsChanged) {
			this.tabs.setItems(tabs);
		}

		this.el.classList.toggle('no-campaign', tabs.length == 0);

		if (tabs.length == 0) {
			this.description = '';
			this.cards.show({
				id: 'no-campaign',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						textContent: _('Žádné kampaně nejsou aktivní'),
					});
				},
			});
			return;
		}

		let tabId = params.get('campaign');
		let tab = tabs.find(t => t.id == tabId);
		if (!tab) {
			tab = tabs[0];
		}

		let filterId = params.get('campaign_filter');
		let filter = this.filter.options.find(i => i.id == filterId) || this.filter.options[0];
		this.filter.setValue(filter.id)

		this.description = tab.campaign.description || '';

		const tabSelected = this.tabs.getSelectedItemData();
		if (!tabSelected || (tabSelected && tabSelected.id !== tab.id)) {
			this.descriptionButton.disabled = !this.description;
		}

		let campaign_changed = this.getSelectedCampaign() != tab.campaign.id;
		this.tabs.setSelected(tab.id);

		let c = await this.cards.show({
			id: 'campaign',
			...this.getListComponentConfig(),
		});

		let extension = Application.session.user.extension;
		if (extension == null) {
			c.setData([]);
			return;
		}

		let [cases, casesChanged] = await Utils.cache(this, 'cases-' + tab.campaign.id, 60000,
			REST.GET, 'outbound/campaigns/' + tab.campaign.id + '/cases', {
			...filter.query,
		}, {signal});

		if (casesChanged || campaign_changed) {
			c.setData(cases);
		}
	},

	timedRefresh() {
		/*
		 * We only refresh if the tab is active. We don't clear the
		 * cache on purpose so that we effectively skip timed reload when
		 * websocket triggered update (which clears the cache) came in
		 * the last minute or so.
		 */
		if (this.el.offsetWidth) {
			this.applyParams(new URLSearchParams(location.search));
		}
	},

	onBusMessage(msg) {
		if (msg.type == 'OUTBOUND_CAMPAIGN_CHANGED') {
			this.reload();
		}

		let current_campaign_id = this.getSelectedCampaign();
		if (!current_campaign_id) {
			Utils.clearCache(this);
			return;
		}

		if (msg.type == 'OUTBOUND_CASE_CHANGED') {
			Utils.clearCache(this, 'cases-' + msg.campaign_id);

			if (msg.campaign_id == current_campaign_id) {
				this.applyParams(new URLSearchParams(location.search));
			}
		}

		if (msg.type == 'CALL_ENDED') {
			this.applyParams(new URLSearchParams(location.search));
		}
	},
});

// }}}

// Phone number history:

// {{{ Office.PhoneNumberHistoryPanel

GW.define('Office.PhoneNumberHistoryPanel', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				className: 'toolbar',
				children: [{
					ref: 'search',
					xtype: 'TextField',
					type: 'search',
					placeholder: _('Vyhledejte telefonní číslo...'),

					/*
					 * Suggest last called numbers.
					 */
					enableSuggestions: true,
					createSuggestionPopup() {
						return new Office.LastContactSuggestionsPopup();
					},
					'on:submit': (c, v) => {
						c.setValue();

						if (v) {
							this.openSearch(v);
						}
					},
					'on:select': (c, v) => {
						c.setValue();

						if (v) {
							this.openSearch(v);
						}
					},
				}],
			}, {
				className: 'tabs',
				children: [{
					ref: 'tabs',
					xtype: 'Widgets.ButtonSwitcher',
					cls: "button-switcher separate",
					renderItem: i => ({
						$data: i,
						'attr:data-item-id': i.id,
						nodeName: 'button',
						className: 'item',
						href: i.href || '#',
						children: [{
							nodeName: 'span',
							className: 'title',
							textContent: i.title,
						}, {
							':skip': i.preventClose || !i.onClose,
							nodeName: 'span',
							className: 'icon-wrapper',
							children: [Utils.useIcon('cross')],
							'on:click': ev => {
								ev.preventDefault();
								i.onClose();
							},
						}],
					}),
					'on:beforeselect': (c, i) => {
						this.selectSearch(i.id);
					},
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);

		this.searches = this.loadSearches();
	},

	/*
	 * Searches management.
	 */

	selectSearch(s) {
		Application.route({
			paramsFn: params => {
				if (!s) {
					params.delete('number_history');
				} else {
					params.set('number_history', s);
				}

				return params;
			},
		});
	},

	loadSearches() {
		let searches = localStorage.getItem('number-history-searches-' + Application.session.user.id);

		return searches ? JSON.parse(searches) : [];
	},

	saveSearches() {
		localStorage.setItem('number-history-searches-' + Application.session.user.id, JSON.stringify(this.searches));
	},

	addSearch(search) {
		if (this.searches.some(s => search === s)) {
			return;
		}

		this.searches.unshift(search);
		this.saveSearches();
	},

	removeSearch(search) {
		this.searches = this.searches.filter(s => s !== search);
		this.saveSearches();
	},

	openSearch(s) {
		s = get_international_number(s);

		this.addSearch(s);
		this.selectSearch(s);
	},

	refreshTabs() {
		let tabs = [];

		let prev_tab = null;
		for (let s of this.searches) {
			let next_sel = prev_tab;

			tabs.push({
				id: s,
				title: s,
				onClose: () => {
					this.removeSearch(s);
					this.selectSearch(next_sel);
				},
			});

			prev_tab = s;
		}

		let sel = this.tabs.getSelected();
		this.tabs.setItems(tabs);
		this.tabs.setSelected(sel);
	},

	reload() {
		Utils.clearCache(this);
		this.applyParams(new URLSearchParams(location.search));
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');

		let search = params.get('number_history');
		if (search) {
			this.addSearch(get_international_number(search));
		}

		this.refreshTabs();
		this.tabs.setSelected(search);
		this.tabs.el.gwHide(this.searches.length == 0);

		if (this.searches.length == 0) {
			this.cards.show({
				id: 'no-number',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty-image-placeholder',
						children: [{
							nodeName: 'img',
							src: APP_BASE + 'img/empty-boxes.svg',
							width: "234",
							height: "190",
						}, {
							className: 'title',
							textContent: _('Vyhledejte telefonní číslo, které vás zajímá'),
						}],
					});
				},
			});
		} else {
			if (!search) {
				search = this.searches[0];
			}

			let c = await this.cards.show({
				id: 'search',
				xtype: 'Office.CallPanel.PhoneNumberHistory',
			});

			let num = search.trim().replace(/\s\+/g, '');

			if (c.last_loaded_number != num) {
				c.showLoading();
			}

			let calls = await REST.GET('calls', {
				extension: num,
				include_notes: true,
				limit: 1000,
			}, {signal});

			c.last_loaded_number = num;
			c.setData(calls, num);
		}
	},
});

// }}}

// {{{ Office.Wallboard

GW.define('Office.Wallboard', 'GW.Component', {
	expandedRows: [],

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				ref: 'dataEl',
			}],
		}, this);

		this.reload();

		Utils.interval(this, 'timers-update', 1000, () => this.updateTimers());

		this.resizeObserver = new ResizeObserver(() => this.updateWidths());
		this.resizeObserver.observe(this.dataEl);
	},

	'before:releaseComponent'() {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect();
			this.resizeObserver = null;
		}
	},
	
	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');
		let group_options = Application.getActiveUserGroup().options;

		function countAsFree(user) {
			if (user.followme) {
				// skip any further checks
				return group_options.free_agent_include_followme;
			}

			if (!user.devices || !user.devices.some(d => d.reachable)) {
				return false;
			}

			if (group_options.free_agent_only_agent_app && !user.session_exists) {
				return false;
			}

			return true;
		}

		this.agents = await REST.GET('agents', null, {signal});

		for (let a of this.agents) {
			a.subscribed_queues = a.queues.filter(q => q.state === 'subscribed' || q.state === 'paused').length;
			a.webrtc_reachable = a.devices && a.devices.some(d => d.kind === 'webrtc' && d.reachable);
			a.phone_reachable  = a.devices && a.devices.some(d => d.kind !== 'webrtc' && d.reachable);
			a.is_free = countAsFree(a);

			let is_subscribed = a.subscribed_queues > 0;
			let is_reachable_internally = a.phone_reachable || a.webrtc_reachable;
			let is_reachable = is_reachable_internally || a.followme;

			a.state = {
				subscribed_not_reachable: is_subscribed && !is_reachable,
				available: is_subscribed && is_reachable_internally && !a.in_call && !a.pause && a.is_free,
				in_call: is_subscribed && a.in_call,
				in_pause: is_subscribed && a.pause,

				not_subscribed_not_reachable: !is_subscribed && !is_reachable,
				not_subscribed_reachable: !is_subscribed && is_reachable,

				external_line: !a.in_call && !a.pause && a.followme,
			};

			if (a.state.available || a.state.in_call || a.state.in_pause) {
				a.sort_group = 0;
			} else if (a.state.not_subscribed_reachable) {
				a.sort_group = 1;
			} else if (a.state.subscribed_not_reachable) {
				a.sort_group = 2;
			} else {
				a.sort_group = 3;
			}
		}

		this.agents.sort((a, b) => {
			if (a.sort_group != b.sort_group) {
				return a.sort_group - b.sort_group;
			}

			return a.name.localeCompare(b.name);
		});

		this.dataEl.gwReplaceChildren(this.agents.map(a => this.renderAgent(a)));
		this.updateTimers();
		this.updateWidths();
	},

	updateWidths() {
		if (!this.el) {
			return;
		}
		const agentsElements = this.el.querySelectorAll('.agent-status');
		if (agentsElements.length) {
			let titleMaxWidth = 0;
			let statusMaxWidth = 0;

			// Get width of widest name column
			agentsElements.forEach(el => {
				el.firstElementChild.style.minWidth = null;
				const cw = el.firstElementChild.clientWidth
				titleMaxWidth = cw > titleMaxWidth ? cw : titleMaxWidth;
			});
			
			// Get width of widest status column (including max. title width)
			agentsElements.forEach(el => {
				const tw = titleMaxWidth - el.firstElementChild.clientWidth
				statusMaxWidth = (tw + el.clientWidth) > statusMaxWidth ? (tw + el.clientWidth) : statusMaxWidth;
			});

			agentsElements.forEach(el => {
				// Set same title max width to all title columns
				el.firstElementChild.style.minWidth = (titleMaxWidth) + 'px';

				// Set same status max width to all status columns
				const p = el.parentElement;
				p.style.minWidth = (statusMaxWidth + 12 + 1) + 'px'; // 12 padding 1 border

				// Do we need to show expander button?
				const showExpander = window.innerWidth < 768 || p.parentElement.scrollHeight > p.parentElement.clientHeight || p.parentElement.clientHeight > 51;
				p.parentElement.firstElementChild.classList.toggle('hidden', !showExpander);
			});
		}
	},

	updateTimers() {
		if (!this.el) {
			return;
		}

		const pause_time = (pause) => {
			if (!pause || !pause.start_ts) {
				return '';
			}
			const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts);
			return Formats.duration_unpadded(Math.max(0, duration));
		};
		this.el.querySelectorAll('.pause-timer').forEach(el => {
			el.textContent = ' ' + pause_time(el.$pause);
		});

		this.el.querySelectorAll('.active-call-dial-ts-timer').forEach(el => {
			el.textContent = ' ' + Formats.duration(Date.now() - el.$dialTs);
		});
	},

	renderAgent(user) {
		const expanded = this.expandedRows.find(e => e === user.user_id);
		return {
			className: 'agent-container ' + ( expanded ? 'expanded' : '' ),
			'attr:data-id': user.user_id,
			children: [{
				nodeName: 'button',
				type: 'button',
				children: [ ( expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'))],
				className: 'expander hidden',
				'on:click': (e) => {
					const expandedIndex = this.expandedRows.indexOf(user.user_id);
					const expanded = expandedIndex === -1;
					
					if (expanded) {
						this.expandedRows.push(user.user_id);
					} else {
						this.expandedRows.splice(expandedIndex, 1);
					}

					e.currentTarget.parentElement.classList.toggle('expanded', expanded);
					e.currentTarget.gwReplaceChildren([Utils.useIcon( expanded ? 'arrow-simple-up' : 'arrow-simple-down')]);
				}
			},{
				className: 'agent-info',
				children: [
					this.renderAgentStatus(user)
				],
			},{
				className: 'agent-queues',
				children: user.queues.map(queue => this.renderQueue(user, queue))
			}
		],
		};
	},

	renderAgentStatus(user) {
		let state = user.state;

		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				children: [{
					className: 'name',
					textContent: user.name,
				}, {
					className: 'extension',
					textContent: user.extension,
					':skip': !user.extension,
				}],
				title: `${user.name + (user.extension ? (' - ' + user.extension) : '')}\n${user.webrtc_reachable ? _('Online') : _('Offline')} - ${user.phone_reachable ? _('Dostupný') : _('Nedostupný')} [${user.subscribed_queues + '/' + user.queues.length}]\n${user.subscribed_queues > 0 ?
						(user.subscribed_queues > 1 ?
							_n(user.subscribed_queues, 'Agent je přihlášen ve {n} frontách') :
							_('Agent je přihlášen v jedné frontě')) :
						_('Agent není přihlášen v žádné frontě')}`,
			}, {
				':skip': !state.subscribed_not_reachable,
				className: 'status-container button xs icon-only static error',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!'),
			}, {
				':skip': !state.not_subscribed_reachable,
				className: 'status-container button xs icon-only static error-secondary',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent není přihlášen ani v jedné frontě!'),
			}, {
				':skip': !state.not_subscribed_not_reachable,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('error'), {textContent: _('Nedostupný')} ],
			}, {
				':skip': !state.available,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle', {cls: 'success'}), {textContent: _('Volný')} ],
				title: _('Aktuálně neprobíhá žádný hovor'),
			}, {
				':skip': !state.external_line,
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Externí linka')} ],
				title: _('Agent je přihlášen na externí lince'),
			}, {
				':skip': !state.in_call,
				className: 'status-container button xs icon-left static primary',
				children: [Utils.useIcon('phone'), {
					textContent: _('Hovoří')
				}, {
					$dialTs: user.active_call_dial_ts,
					className: 'active-call-dial-ts-timer',
				}],
			}, {
				':skip': !state.in_pause,
				className: 'status-container button xs icon-left static warning',
				children: [Utils.useIcon( 'play'), {
					title: ((user.pause && user.pause.pause_type) ? user.pause.pause_type.name : ''),
					children: [{
						nodeName: 'span',
						textContent: _('Pauza'),
					}, {
						nodeName: 'span',
						textContent: (user.pause && user.pause.pause_type) ? ' (' + user.pause.pause_type.name + ')' : '',
						className: 'pause-name',
					}, {
						nodeName: 'span',
						$pause: user.pause,
						className: 'pause-timer',
					}]
				}],
			}],
		};
	},

	renderQueue(user, queue) {
		return {
			className: 'queue',
			'attr:data-status': (user && user.active_calls_queues && user.active_calls_queues.includes(queue.queue)) ? 'in-queue-call' : queue.state, // unsubscribed subscribed paused
			'attr:data-static': queue.static_membership ? '1' : '0',
			title: queue.static_membership ? _c('Přihlášen trvale', 'queue') : undefined,
			children: [{
				className: 'status',
			}, {
				className: 'info' + (!queue.name ? ' no-name' : ''),
				children: [{
					'skip:': !queue.name,
					className: 'name',
					textContent: queue.name,
					title: queue.name,
				}, {
					className: 'number',
					textContent: queue.queue,
				}],
			}],
		};
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
	
	applyParams() {
		Application.refreshSubscriptionsFromDOM();
	},
});

// }}}

// Statistics:

// {{{ Office.Statistics

GW.define('Office.Statistics', 'GW.Component', {
	queuesTableOpen: false,
	callbacksTableOpen: false,
	data: {},

	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				className: 'top-bar',
				children: [{
					nodeName: "h3",
					className: "title",
					textContent: _("Osobní statistiky"),
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('reset'), {textContent: _('Obnovit')}],
					'on:click': () => this.reload(),
				}],
			}, {
				className: "charts",
				ref: "charts",
			}, {
				className: "table",
				children: [{
					className: "panel-header",
					children: [{
						nodeName: "h5",
						className: 'title',
						textContent: _("Příchozí frontové hovory"),
					}, {
						nodeName: "button",
						type: "button",
						ref: "queuesExpander",
						className: 'transparent small icon-only expander',
						children: [ this.queuesTableOpen ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down') ],
						"on:click": () => {
							this.queuesTableOpen = !this.queuesTableOpen;
							this.renderQueuesTable(this.queuesTableOpen);
						},
					}]
				}, {
					xtype: "SmartTable",
					extraClass: 'table-alternative',
					ref: "queuesTable",
					getColumns() {
						return [{
							id: "queue",
							name: _("Fronta"),
						}, {
							id: "count",
							name: _("Celkem příchozích"),
						}, {
							id: "count_connected",
							name: _("Dovolané"),
						}, {
							id: "count_not_connected",
							name: _("Nedovolané"),
						}, {
							id: "avg_ring_duration",
							name: _("Průměrná délka vyzvánění"),
							format: "duration",
						}, {
							id: "avg_duration",
							name: _("Průměrná délka hovoru"),
							format: "duration",
						}, {
							id: "sum_duration",
							name: _("Celková délka hovorů"),
							format: "duration",
						}];
					}
				}]
			}, {
				className: "table",
				children: [{
					className: "panel-header",
					children: [{
						nodeName: "h5",
						className: 'title',
						textContent: _("Callback"),
					}, {
						nodeName: "button",
						type: "button",
						ref: "callbacksExpander",
						className: 'transparent small icon-only expander',
						children: [ this.callbacksTableOpen ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down') ],
						"on:click": () => {
							this.callbacksTableOpen = !this.callbacksTableOpen;
							this.renderCallbacksTable(this.callbacksTableOpen);
						},
					}]
				}, {
					xtype: "SmartTable",
					extraClass: 'table-alternative',
					ref: "callbacksTable",
					getColumns() {
						return [{
							id: "queue",
							name: _("Fronta"),
						}, {
							id: "callback_count",
							name: _("Celkem callbacků"),
						}, {
							id: "call_count",
							name: _("Zavolání"),
						}, {
							id: "success_count",
							name: _("Pozitivní zakončení"),
						}, {
							id: "fail_count",
							name: _("Negativní zakončení"),
						}, {
							id: "first_reaction_duration_avg",
							name: _("Průměrná doba první reakce"),
							format: "duration",
						}, {
							id: "close_duration_avg",
							name: _("Průměrná doba uzavření"),
							format: "duration",
						}];
					}
				}]
			}],
		}, this);
	},

	renderCharts(data) {
		this.charts.gwReplaceChildren([{
			className: "chart-attendance",
			xtype: "Office.Statistics.BigChart",
			title: _("Docházka"),
			data: data.attendance,
		}, {
			className: "chart-pauses",
			xtype: "Office.Statistics.BigChart",
			title: _("Pauzy"),
			data: data.pauses,
		}, {
			className: "additional-charts",
			children: [{
				nodeName: "h5",
				className: 'title',
				textContent: _("Příchozí hovory - Úroveň služby"),
			}, this.makePercentageChart(data.service_ratio), {
				nodeName: "h5",
				className: 'title',
				textContent: _("Callback - Graf uzavření případů"),
			}, this.makePercentageChart(data.callback_success_rate)],
		}], this);
	},

	renderQueuesTable(expanded) {
		this.queuesExpander.gwReplaceChildren([
			expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'),
		]);

		this.queuesTable.setData(expanded ? this.data.queue_stats : this.data.queue_stats.slice(0, 1));
		this.queuesExpander.disabled = this.data.queue_stats.length < 2;

		if (expanded) {
			setTimeout(this.queuesExpander.parentElement.scrollIntoView({behavior: "smooth", block: "start", inline: "start"}), 150);
		}
	},

	renderCallbacksTable(expanded) {
		this.callbacksExpander.gwReplaceChildren([
			expanded ? Utils.useIcon('arrow-simple-up') : Utils.useIcon('arrow-simple-down'),
		])

		this.callbacksTable.setData(expanded ? this.data.callback_stats : this.data.callback_stats.slice(0, 1));
		this.callbacksExpander.disabled = this.data.callback_stats.length < 2;

		if (expanded) {
			setTimeout(this.callbacksExpander.parentElement.scrollIntoView({behavior: "smooth", block: "start", inline: "start"}), 150);
		}
	},

	makePercentageChart(value) {
		const chartEl = document.gwCreateElement({
			className: "chart",
		});

		Charts.makeDoughnut(chartEl, [{
			value: value,
			color: Utils.getStyleRootProperty("--graph-success-color"),
		}, {
			value: 1-value,
			color: Utils.getStyleRootProperty("--graph-error-color"),
		}]);

		return document.gwCreateElement({
			className: "percentage-chart",
			children: [chartEl, {
				className: "percentage",
				textContent: Formats.percent(value),
			}],
		});
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'load-state');

		let data = await REST.GET("/api/personal-statistics", null, {signal});

		if (data.presence.call + data.presence.pause + data.presence.free + data.presence.login === 0) {
			data.presence.login = 1; // add one second to login so we have something to show in the chart
		}

		function chartLabel(label, color_index, color_prefix, value) {
			return {
				label,
				value,
				color: Utils.getStyleRootProperty(`--${color_prefix}-color-${color_index}`) || `hsl(${((color_index + 1) * 50) % 360}, 100%, 40%)`,
			}
		}

		const attendanceData = [
			chartLabel(_("V pauze"), 0, 'attendance', data.presence.pause / 1000),
			chartLabel(_("V hovoru"), 1, 'attendance', data.presence.call / 1000),
			chartLabel(_("Volný"), 2, 'attendance', data.presence.free / 1000),
			chartLabel(_("Přihlášen"), 3, 'attendance', data.presence.login / 1000),
		];

		this.renderCharts({
			attendance: attendanceData,
			pauses: data.pauses.map((pause, i) => chartLabel(pause.name || _('Autopauza'), i, 'pause' , pause.duration / 1000)),
			service_ratio: data.queue_stats[0].count > 0 ? data.queue_stats[0].count_connected / data.queue_stats[0].count : 0,
			callback_success_rate: data.callback_stats[0].callback_count > 0 ? data.callback_stats[0].success_count / data.callback_stats[0].callback_count : 0,
		});

		this.data = data;
		this.data.queue_stats[0].queue = _("Všechny fronty");
		this.data.callback_stats[0].queue = _("Všechny fronty");
		this.renderQueuesTable(this.queuesTableOpen);
		this.renderCallbacksTable(this.callbacksTableOpen);
	},

	async applyParams() {
		await this.reload();
	},
});

// }}}

// {{{ Office.Statistics.BigChart

GW.define("Office.Statistics.BigChart", "GW.Component", {
	title: '',
	data: [],

	initComponent() {
		let noData = false;
		if (this.data.length === 0) {
			noData = true;
			this.data = [{label: null, value: 1, color: Utils.getStyleRootProperty("--input-placeholder")}];
		}

		const total = this.data.map(i => i.value).reduce((a, b) => a + b);

		const doughnut = document.gwCreateElement({className: "chart"});
		Charts.makeDoughnut(
			doughnut,
			this.data.map(i => {
				return {...i, value: i.value/total};
			}),
			null,
			{}, {
				responsive: true,
				aspectRatio: 1.222,
				maintainAspectRatio: true,
				animation: true,
				cutout: '50%',
				events: [],
				borderWidth: 2,
				borderColor: Utils.getStyleRootProperty('--panel-bg'),
				layout: {
					autoPadding: false,
					top: 0,
					bottom: 0,
					left: 20,
					right: 20,
				}
			}
		);

		this.el = document.gwCreateElement({
			className: `big-doughnut`,
			children: [doughnut, {
				className: "legend",
				children: [{
					nodeName: "h5",
					className: 'title',
					textContent: this.title
				}, {
					className: 'detail',
					textContent: _("Celkem {time}").replace("{time}", Utils.secondsToHoursMinutes(noData ? 0 : total))
				}, {
					":skip": noData,
					className: "data",
					children: this.data.map(i => {
						return {
							className: "item",
							children: [{
								className: "dot",
								style: {backgroundColor: i.color}
							}, {
								className: "label",
								textContent: `${Formats.percent(i.value/total)} - ${i.label} (${Utils.secondsToHoursMinutes(i.value)})`
							}]
						}
					})
				}]
			}]
		});
	}
});

// }}}

// Callback:

// {{{ Office.AgentCallbackPanel

GW.define('Office.AgentCallbackPanel', 'GW.Component', {
	buttonSwitcherExtraClass: '',
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: [{
						ref: 'tabs',
						xtype: 'Widgets.ButtonSwitcher',
						cls: "button-switcher small campaign-switcher " + this.buttonSwitcherExtraClass,
						'on:beforeselect': (c, i) => {
							Application.route({
								paramsFn: params => {
									params.set('callback_queue', i.id);
									return params;
								},
							});
						},
					}, {
						ref: 'filter',
						xtype: 'SelectField',
						cls: 'small',
						popupAutoWidth: false,
						options: this.getFilterOptions(),
						'on:change': c => {
							Application.route({
								paramsFn: params => {
									params.set('callback_filter', c.getValue());
									return params;
								},
							});
						},
					}],
				}],
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);
		
		// reload queues only if queue manager is not active. The queues may be not loaded or outdated in this cases.
		if (!Office.QueueManager.active) {
			Office.QueueManager.loadQueues(false);
		}
	},

	getFilterOptions() {
		return [{
			id: 'all',
			value: 'all',
			text: _('Všechny případy'),
			query: {},
		}, {
			id: 'open',
			value: 'open',
			text: _('Všechny otevřené'),
			query: {
				status: 'not-closed',
			},
		}, {
			id: 'mine',
			value: 'mine',
			text: _('Moje otevřené'),
			query: {
				mine: true,
				status: 'not-closed',
			},
		}, {
			id: 'all-closed',
			value: 'all-closed',
			text: _('Všechny uzavřené'),
			query: {
				status: 'closed',
			},
		}, {
			id: 'mine-closed',
			value: 'mine-closed',
			text: _('Moje uzavřené'),
			query: {
				mine: true,
				status: 'closed',
			},
		}, {
			id: 'new',
			value: 'new',
			text: _('Nezahájené'),
			query: {
				status: 'new',
			},
		}];
	},

	renderPhoneNumber(ct, number) {
		ct.textContent = number || '';
	},

	getListComponentConfig() {
		let me = this;

		return {
			xtype: 'SmartTable',
			monitorOverflow: true,
			extraClass: 'outbound-cases-smart-table js-msgbus',
			getColumns() {
				return [{
					id: 'contact_phone',
					name: _('Telefon'),
					formatCell(td, v, row) {
						me.renderPhoneNumber(td, v);
						td.prepend(
							td.gwCreateChild({
								nodeName: 'span',
								className: 'icon-wrapper',
								title: row.requested_by_caller ? _('Vyžádaný callback') : _('Zmeškaný hovor'),
								children: [
									row.requested_by_caller ? 
										Utils.useIcon('notificationsfilled', {cls: 'warning'})
									:
										Utils.useIcon('phone-missed', {cls: 'muted'})
								],
							})
						);
					},
				}, {
					id: 'contact_name',
					name: _('Jméno'),
				}, {
					id: 'contact_company',
					name: _('Firma'),
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren([{
							':skip': !row.queue_name,
							textContent: row.queue_name,
							className: 'text-nowrap',
						}, {
							textContent: row.queue,
							className: row.queue_name ? 'text-sm' : '',
						}])
					},
				}, {
					id: 'first_agent_exten',
					name: _('Linka'),
					formatCell: (td, v, row) => {
						if (row.first_agent_more) {
							td.gwReplaceChildren([{
								nodeName: 'em',
								textContent: _('Více agentů'),
							}])
						} else {
							me.renderPhoneNumber(td, v, row);
						}
					},
				}, {
					id: 'first_agent_name',
					name: _('Agent'),
				}, {
					id: 'last_missed',
					name: _('Čas zmeškaného hovoru'),
					format: 'datetime',
				}, {
					id: 'contact_incomming_misses',
					name: _('Počet zmeškání'),
				}, {
					id: 'agent_outgoing_attempts',
					name: _('Počet pokusů'),
				}, {
					id: 'last_contact',
					name: _('Čas posledního pokusu'),
					format: 'datetime',
				}, {
					id: 'last_agent_name',
					name: _('Vyřizuje'),
				}, {
					id: 'last_agent_exten',
					name: _('Linka'),
					formatCell: me.renderPhoneNumber,
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell: (...args) => me.renderCaseControls(...args),
				}];
			},

			renderRow(tr, row) {
				tr.dataset.status = row.status || '';
				tr.dataset.mine = row.last_agent_user_id == Application.session.user.id ? '1' : '0';
			},

			refreshControls() {
				for (let btn of this.el.querySelectorAll('button[data-action]')) {
					let action = btn.dataset.action;
					switch (action) {
					case 'outbound-case-notes':
						btn.disabled = false;
						break;
					case 'outbound-case-close':
					case 'outbound-case-close-fail':
						btn.disabled = false; //XXX: disable when other agent is working on this case
						break;
					default:
						btn.disabled = !Office.CallManager.canDo(action);
						break;
					}
				}
			},

			onBusMessage(msg) {
				if (msg.type == 'CALL_MANAGER_CHANGE') {
					this.refreshControls();
				}
			},

			'after:setData'() {
				this.refreshControls();
			},
		};
	},

	renderCaseControls(td, v, row) {
		if (this.showDialButton()) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'success icon-only small',
				'attr:data-action': 'dial',
				title: _('Vytočit'),
				'on:click': ev => {
					this.onDial(row);
				},
			});
		}

		td.gwCreateChild({
			nodeName: 'button',
			className: 'secondary icon-only small' + (row.has_notes ? ' filled' : ''),
			'attr:data-action': 'outbound-case-notes',
			title: _('Poznámky'),
			'on:click': ev => {
				ev.preventDefault();
				this.showNotesDialog(row);
			},
		});

		if (row.status === 'closed') {
			td.gwCreateChild({
				nodeName: 'span',
				className: 'status icon ' + (row.close_result === 'success' ? 'success' : 'error'),
				children: [Utils.useIcon(row.close_result === "success" ? 'check' : 'cross'), {
					textContent: (row.close_result === "success" ? _('Úspěšné') : _('Neúspěšné'))
				}]
			});
		} else {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'icon-only small ' + (row.close_result == 'success' ? 'primary selected' : 'secondary'),
				'attr:data-action': 'outbound-case-close',
				title: _('Uzavřít - úspěšné'),
				'on:click': ev => {
					ev.preventDefault();
					this.closeCase(row, 'success');
				},
			});

			td.gwCreateChild({
				nodeName: 'button',
				className: 'icon-only small ' + (row.close_result == 'fail' ? 'primary error selected' : 'secondary'),
				'attr:data-action': 'outbound-case-close-fail',
				title: _('Uzavřít - neuspěšné'),
				'on:click': ev => {
					ev.preventDefault();
					this.closeCase(row, 'fail');
				},
			});
		}
	},

	async closeCase(data, close_result) {
		await REST.POST('callback-cases/' + encodeURIComponent(data.id) + '/close', {close_result});
		this.reload();
	},

	showNotesDialog(data) {
		new Main.NotesDialog({
			onSave(text) {
				return REST.POST('callback-cases/' + encodeURIComponent(data.id) + '/comments', {
					text,
				});
			},

			loadData(signal) {
				return REST.GET('callback-cases/' + encodeURIComponent(data.id) + '/comments', null, {signal});
			},
		});
	},

	async onDial(data) {
		await REST.POST('callback-cases/' + encodeURIComponent(data.id) + '/activate');
		this.reload();
		
		let number = await Office.QueueManager.makeQueueAssignmentNumber(data.queue, data.contact_phone);

		Office.CallManager.doAction({action: 'dial', number, send_metadata: {callback_case: data.id}});
	},

	showDialButton() {
		return true;
	},

	reload() {
		Utils.clearCache(this);

		this.applyParams(new URLSearchParams(location.search));
	},

	cachedReload() {
		this.applyParams(new URLSearchParams(location.search));
	},

	async applyParams(params) {
		let signal = Utils.abortAndRetry(this, 'reload');

		/*
		 * Update toplevel tabs (queue list)
		 */
		let tabs = Office.QueueManager.queues.map(c => {
			return {
				id: 'queue-' + c.queue,
				title: c.queue + (c.name ? ` - ${c.name}` : ''),
				queue: c.queue,
			};
		});

		tabs.unshift({
			id: 'any-queue',
			title: _('Všechny'),
		});

		this.tabs.setItems(tabs);

		/*
		 * Handle the "no queues" case.
		 */
		this.el.classList.toggle('no-queues', tabs.length == 1);

		if (tabs.length == 1) {
			this.description = '';
			this.cards.show({
				id: 'no-queues',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						textContent: _('Žádné fronty nejsou k dispozici'),
					});
				},
			});
			return;
		}

		/*
		 * Handle queue selection.
		 */
		let tabId = params.get('callback_queue');
		let tab = tabs.find(t => t.id == tabId) || tabs[0];
		this.tabs.setSelected(tab.id);

		/*
		 * Handle case filter type selection.
		 */
		let filterId = params.get('callback_filter');
		let filter = this.filter.options.find(i => i.value == filterId) || this.filter.options[1];
		this.filter.setValue(filter.value);

		/*
		 * Render or activate the case list.
		 */
		let c = await this.cards.show({
			id: 'cases',
			...this.getListComponentConfig(),
		});

		/*
		 * If user does not have extension assigned, don't try to load
		 * the cases.
		 */
		let extension = Application.session.user.extension;
		if (extension == null) {
			c.setData([]);
			return;
		}

		/*
		 * Update the case list.
		 */
		let [cases, casesChanged] = await Utils.cache(this, 'cases', 60000,
			REST.GET, 'callback-cases', {...filter.query, queue: tab.queue}, {signal});
		if (casesChanged) {
			c.setData(cases);
		}
	},

	onBusMessage(msg) {
		let tab = this.tabs.getSelectedItemData();
		let queue = tab ? tab.queue : null;

		if (msg.type == 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.cachedReload();
		}

		if (msg.type == 'CALLBACK_CASE_CHANGED') {
			Utils.clearCache(this, 'cases');

			if (!queue || msg.queue == queue) {
				this.cachedReload();
			}
		}

		if (msg.type == 'CALL_ENDED') {
			this.cachedReload();
		}
	},
});

// }}}
// {{{ Office.AgentDialer

GW.define('Office.AgentDialer', 'GW.Component', {
	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				ref: 'officeDialer',
				xtype: 'Office.Dialer',
				'after:initComponent'() {
					this.inputOptions.gwReplaceChildren([{
						xtype: 'SelectField',
						cls: 'small project-select',
						ref: 'projectSelect',
						placeholder: _('Bez projektu'),
						'on:change': el => {
							localStorage.setItem('agent-dialer-project', el.getValue());
						}
					}], me);
				},
				async 'wrap:callManagerAction'(origFn, args) {
					if (args.action === 'dial') {
						const selectedProjectQueue = me.projectSelect.getValue();
						if (selectedProjectQueue) {
							args.number = await Office.QueueManager.makeQueueAssignmentNumber(selectedProjectQueue, args.number, true);
						}
					}
					origFn(args);
				}
			}, {
				className: 'office-waiting-queues panel-container js-msgbus',
				children: [{
					nodeName: 'h4',
					textContent: _('Frontové požadavky'),
				}, {
					className: 'call-list',
					ref: 'queueCallsList',
				}],
			}],
		}, this);

		Utils.interval(this, 'timer-update', 1000, () => this.updateTimers());

		this.renderQueueCallsList(Office.QueueManager.queued_calls);
	},

	updateProjectSelect() {
		let select = this.projectSelect;

		let queues = Office.QueueManager.queues
			.filter(q => q.supports_out_prefix)
			.filter(q => (
				(Application.getActiveUserGroup().options.projects_show_queues && q.type == 'agent') ||
				(Application.getActiveUserGroup().options.projects_show_personal_queues && q.type == 'personal')
			))
			.sort((q1, q2) => ((q2.type == 'personal') - (q1.type == 'personal'))); // sort personal first

		if (queues.length <= 0) {
			select.el.gwHide(true);
			return;
		}
		select.el.gwHide(false);

		const separator = {
			render: {
				className: 'option separator',
			},
		}

		select.setOptions([
			{
				text: _('Bez projektu'),
				value: null,
			},
			separator,
			...queues.flatMap((q, i, arr) => [
				...(i > 0 && arr[i].type != arr[i-1].type ? [separator] : []),
				{
					text: (q.name ? (q.name + ' - ') : '') + q.queue,
					value: q.queue
				}
			]),
		]);
		
		select.setValue(localStorage.getItem('agent-dialer-project'));
	},

	renderQueueCallsList({calls, details}) {
		if (env.FEATURE_FLAGS.emailAndSms) {
			calls = [
				...(calls || []).map(c => ({...c, type: 'phone'})),
				{
					caller: '+420 777 434 788',
					queue: '9001',
					queue_join_ts: (Date.now() / 1000) - 60,
					type: 'phone',
				}, {
					caller: '+420 776 358 987',
					queue: '9001',
					queue_join_ts: (Date.now() / 1000) - 60,
					type: 'phone',
				}, {
					caller: '+420 777 434 788',
					queue: '+420 777 888 991',
					queue_join_ts: (Date.now() / 1000) - 60,
					type: 'sms',
				}, {
					caller: 'localhost@localhost.local',
					queue: 'info@evilcorp.com',
					queue_join_ts: (Date.now() / 1000) - 60,
					type: 'email',
				}, {
					caller: 'pepa@votrava.eu',
					queue: 'info@evilcorp.com',
					queue_join_ts: (Date.now() / 1000) - 60,
					type: 'email',
				},
			];

			// add dummy data of waiting email and sms
			details = {
				...(details || {}),
				contacts: [
					...(details ? details.contacts : []),
					{
						phone: '+420 777 434 788',
						name: 'Petr Polívka',
						company: 'Korporát ABC',
					}, {
						phone: '+420 777 434 788',
						name: 'Petr Polívka',
						company: 'Korporát ABC',
					}, {
						phone: 'info@evilcorp.com', // XXX use email instead, not phone
						name: 'Petr Polívka',
						company: 'Korporát ABC',
					}, {
						phone: 'info@evilcorp.com', // XXX use email instead, not phone
						name: 'Petr Polívka',
						company: 'Korporát ABC',
					}, {
						phone: 'info@evilcorp.com', // XXX use email instead, not phone
						name: 'Petr Polívka',
						company: 'Korporát ABC',
					}
				],
				queues: [
					...(details ? details.queues : []),
					{
						queue: '+420 777 888 991',
					}
				]
			};
		}
		
		if (!calls || calls.length <= 0) {
			this.queueCallsList.gwReplaceChildren([{
				textContent: _('Žádné frontové požadavky'),
			}]);
			this.queueCallsList.parentNode.classList.add('queue-empty')
			return;
		} else {
			this.queueCallsList.parentNode.classList.remove('queue-empty')
		}

		this.queueCallsList.gwReplaceChildren(calls.map(call => {
			const contact = details && details.contacts.find(c => c.phone == call.caller);
			const queue = details && details.queues.find(q => q.queue == call.queue);

			return {
				className: 'call-container',
				children:[ {
					className: 'call-type-container',
					children: [{
						className: 'call-type-icon',
						children: [Utils.useIcon( call.type === "sms" ? 'commentrounded' : call.type === "email" ? 'envelope' : 'phone')],
					}]}, {
					className: 'call',
					children: [{
						className: 'number',
						textContent: call.caller,
					}, {
						className: 'contact',
						textContent: contact ? [contact.name, contact.company].filter(v => v).join(', ') : '',
					}, {
						className: 'queue',
						textContent: _('Fronta') + ' ' + call.queue + ((queue && queue.name) ? ` - ${queue.name}` : ''),
					}, {
						className: 'queue-join-timer',
						$queue_join_ts: call.queue_join_ts,
					}, {
						':skip': !(call.type === 'email' || call.type === 'sms'),
						nodeName: 'button',
						className: 'success small icon-left button-block',
						children: [Utils.useIcon('plus'), { textContent: _('Přijmout') }],
						'on:click': () => {
							// nothing for dummy data
						},
					}],
				}]
			};
		}));

		this.updateTimers();
	},

	updateTimers() {
		for (let el of this.queueCallsList.querySelectorAll('.queue-join-timer')) {
			el.textContent = el.$queue_join_ts ? Utils.getElapsedTime(el.$queue_join_ts) : '';
		}
	},

	async showCallEndedDialog(call_id, queue) {
		let selectCategory = Application.getActiveUserGroup().options.force_select_category;
		let addNote = Application.getActiveUserGroup().options.force_add_note;
		let categoryIsSet = false;

		let hierarchy;
		if (selectCategory) {
			hierarchy = await Office.QueueManager.getCategoryHierarchy(queue);
			if (!hierarchy) {
				// do not show category selection if no hierarchy set for given queue
				selectCategory = false;
			} else {
				const call_info = await REST.GET('call-info/' + encodeURIComponent(call_id));
				categoryIsSet = call_info.call_category && call_info.call_category.length > 0;
			}
		}

		if (!selectCategory && !addNote) {
			// dialog will not be shown
			return;
		}
		if (selectCategory && !addNote && categoryIsSet) {
			// only category selection is requested, but category already set, no need to show the dialog
			return;
		}

		/* best effor call info fetch */
		let detail;
		try {
			detail = await REST.GET('calls/' + encodeURIComponent(call_id));
		} catch (ex) { }

		new Main.FormDialog({
			allowCloseButton: false,
			disableSubmitOnInvalidForm: true,

			title: (selectCategory && addNote) ?
				_('Vybrat kategorii a přidat poznámku') : (
				selectCategory ? _('Vybrat kategorii') : _('Přidat poznámku')
			) + (hierarchy ? (' - ' + hierarchy.name) : ''),

			'after:initComponent'() {
				this.el.classList.add('call-ended-dialog');

				if (this.categoriesField) {
					this.categoriesField.setCategoryList(hierarchy.categories);
				}

				this.focus();
			},

			renderFormFields() {
				return [{
					':skip': !detail,
					ref: 'detailEl',
					xtype: 'FormField',
					label: _('Pro hovor z'),
					optional: true,
					renderInput() {
						return {
							ref: 'input',
							textContent: Formats.datetime(detail.begin_ts),
						};
					},
				}, {
					':skip': !detail,
					ref: 'detailEl',
					xtype: 'FormField',
					label: _('Volající a volaný'),
					optional: true,
					renderInput() {
						return {
							ref: 'input',
							children: [
								detail.caller,
								' -> ',
								detail.last_callee,
							],
						};
					},
				}, {
					':skip': !selectCategory,
					ref: 'categoriesField',
					name: 'category',
					xtype: 'Office.CallPanel.CategorySelector',
				}, {
					':skip': !addNote,
					ref: 'noteField',
					name: 'note',
					xtype: 'TextareaField',
					label: _('Přidat poznámku k hovoru'),
				}];
			},

			async onSave(data) {
				// parallel - make it faster and don't let one error fail the other request
				await Promise.all([
					selectCategory && REST.PUT('call-info/' + encodeURIComponent(call_id), {category: data.category}),
					addNote && REST.POST('call-info/' + encodeURIComponent(call_id) + '/notes', {note: data.note}),
				]);
			},
		});
	},

	showCallbackCaseCallEndedDialog(outbound_case_id) {
		new Main.Dialog({
			title: _('Zvolte výsledek hovoru'),
			allowCloseButton: false,
			'after:initComponent'() {
				this.bodyEl.gwCreateChild({
					className: 'form-buttons centered',
					children: [{
						nodeName: 'button',
						type: 'button',
						className: 'success large icon-left',
						children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Úspěch'),}],
						'on:click': async () => {
							// hide dialog and make request in the background - don't block dialog on error or timeout
							PopupManager.hide(this);
							await REST.POST('callback-cases/' + encodeURIComponent(outbound_case_id) + '/close', {close_result: 'success'});
						},
					}, {
						nodeName: 'button',
						type: 'button',
						className: 'error large icon-left',
						children: [ Utils.useIcon('error'), {textContent: _('Neúspěch'),}],
						'on:click': async () => {
							// hide dialog and make request in the background - don't block dialog on error or timeout
							PopupManager.hide(this);
							await REST.POST('callback-cases/' + encodeURIComponent(outbound_case_id) + '/close', {close_result: 'fail'});
						},
					}],
				});
				this.footerEl.gwCreateChild({nodeName:'br'});
			},
		});
	},

	onBusMessage(msg) {
		const my_exten = Application.session.user.extension

		if (msg.type === 'CALL_ENDED' &&
			(msg.last_callee == my_exten || msg.caller == my_exten) &&
			msg.queue
		) {
			// this is called only for connected calls, not connected queue calls does not have
			// callee (neither last_callee) set
			this.showCallEndedDialog(msg.call_id, msg.queue)
				// don't bother the user with error not related to CALL_ENDED event
				.catch(console.error);
		}
		
		if (msg.type === 'CALL_ENDED' && 
			msg.caller == my_exten &&
			Application.getActiveUserGroup().options.show_window_for_callback_case_close
		) {
			REST.GET('call-info/' + msg.call_id).then(({call_metadata}) => {
				if (call_metadata && call_metadata.callback_case) {
					this.showCallbackCaseCallEndedDialog(call_metadata.callback_case);
				}
			}).catch(console.error);
		}
		
		if (msg.type === 'QUEUE_MANAGER_QUEUES_LIST_CHANGE') {
			this.updateProjectSelect();
		}

		if (msg.type == 'QUEUE_MANAGER_QUEUED_CALLS_CHANGE') {
			this.renderQueueCallsList(Office.QueueManager.queued_calls);
		}
	},
});

// }}}
// {{{ Office.AgentPanel

GW.define('Office.AgentPanel', 'Office.OfficePanel', {
	title: _('Agent panel'),
	titleIcon: 'headphones',

	extendOfficePanel() {
		this.queueControl = new Office.QueueControlPanel({
			'after:initComponent'() {
				this.el.classList.add('page-centered-container');
			},
		});

		this.bodyEl.before(this.queueControl.el);
	},

	getDialerConfig() {
		return {
			xtype: 'Office.AgentDialer',
		};
	},

	renderPhoneNumber(ct, number) {
		if (number) {
			ct.gwCreateChild({
				nodeName: 'a',
				className: 'phone-number-link',
				textContent: number,
				href: '#',
			});
		}
	},

	getControlPanelTabs(hiddenTabs) {
		if (!hiddenTabs) {
			hiddenTabs = Application.getActiveUserGroup().options.hidden_agent_panel_tabs || [];
		}
		return [{
			id: 'call',
			icon: 'document',
			title: _('Karta hovoru'),
			href: '#',
			card: {
				xtype: 'Office.CallPanel',
			},
		}, ...(env.FEATURE_FLAGS.emailAndSms ? [{
			id: 'email',
			icon: 'envelope',
			title: _('Emaily'),
			href: '#',
			card: {
				xtype: 'Office.DummyEmailPanel',
			},
		}, {
			id: 'sms',
			icon: 'commentrounded',
			title: _('SMS'),
			href: '#',
			card: {
				xtype: 'Office.DummySmsPanel',
			},
		}] : []), ...((env.SMS_ACCOUNTS && env.SMS_ACCOUNTS.length) ? [{
			id: 'smsgate',
			icon: 'commentrounded',
			title: _('SMS brána'),
			href: '#',
			card: {
				xtype: 'Office.SmsGate',
			}
		}] : []), {
			id: 'speeddial',
			icon: 'dashboard',
			title: _('Rychlé volby'),
			href: '#',
			card: {
				xtype: 'Office.Speeddial',
			},
		}, {
			id: 'history',
			icon: 'phone',
			title: _('Historie volání'),
			href: '#',
			card: {
				xtype: 'Office.HistoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'queuehistory',
			icon: 'queue',
			title: _('Historie front'),
			href: '#',
			card: {
				xtype: 'Office.AgentHistoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'callback',
			icon: 'phone-missed',
			title: _('Callback'),
			href: '#',
			card: {
				xtype: 'Office.AgentCallbackPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'outbound',
			icon: 'phone-outgoing',
			title: _('Odchozí kampaně'),
			href: '#',
			card: {
				xtype: 'Office.AgentOutboundPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}, {
			id: 'numberhistory',
			icon: 'phone',
			title: _('Historie čísel'),
			href: '#',
			card: {
				xtype: 'Office.PhoneNumberHistoryPanel',
			},
		}, {
			id: 'wallboard',
			icon: 'headphones',
			title: _('Agenti'),
			href: '#',
			card: {
				xtype: 'Office.Wallboard',
			},
		}, {
			id: 'stats',
			icon: 'chart',
			title: _('Statistiky'),
			href: '#',
			card: {
				xtype: 'Office.Statistics',
			},
		}, {
			id: 'directory',
			icon: 'book',
			title: _('Adresář'),
			href: '#',
			card: {
				xtype: 'Office.DirectoryPanel',
				renderPhoneNumber: this.renderPhoneNumber,
			},
		}].filter(tab => !hiddenTabs.includes(tab.id));
	},

	'wrap:getMovedCards'(fn) {
		let tabs = fn();
		let me = this;

		if (Application.getResponsivityMatch('<md')) {
			return [{
				id: 'queues',
				icon: 'phone-call',
				title: _('Fronty'),
				href: '#',
				card: {
					xtype: 'Office.QueueControlPanel',
					applyParams(params) {
						this.redrawQueues();
					},
				},
			}, ...tabs];
		}

		return tabs;
	},

	'after:layoutAutoHide'() {
		const ltmd = Application.getResponsivityMatch('<md');

		this.queueControl.el.gwHide(ltmd);

		if (!ltmd) {
			this.control.cards.remove('queues');
		}
	},

	'after:initComponent'() {
		this.el.addEventListener('click', ev => {
			if (ev.target.matches('a.phone-number-link')) {
				ev.preventDefault();

				Application.route({
					paramsFn: params => {
						params.set('number_history', ev.target.textContent);
						params.set('tab', 'numberhistory');
						return params;
					},
				});
			}
		}, true);

		Office.QueueManager.start();
	},

	'before:destroy'() {
		Office.QueueManager.end();
	},

	requestReload() {
		Utils.abortDedupeCalls(this, 'update-callback-stats');
		this.reloadCallbackStats();

		Utils.abortDedupeCalls(this, 'update-sms-stats');
		this.reloadSmsStats();
	},

	renderCallbackStats() {
		let queues = this.callbackStats || [];
		let total = queues.reduce((tot, q) => tot + q.new_cases, 0);
		let notify = false;
		if (total > 0) {
			notify = String(total > 99 ? '99+' : total);
		}

		this.control.tabs.setNotification('callback', notify);
	},

	async reloadCallbackStats() {
		let signal = Utils.abortAndRetry(this, 'reload-callback-stats');

		this.callbackStats = await REST.GET('callback-cases/summary', null, {signal});

		this.renderCallbackStats();
	},
	
	async reloadSmsStats() {
		let signal = Utils.abortAndRetry(this, 'reload-sms-stats');
		const summary = await REST.GET('sms/summary', null, {signal});
		let total = summary.not_read_count;
		let notify = false;
		if (total > 0) {
			notify = String(total > 99 ? '99+' : total);
		}
		this.control.tabs.setNotification('smsgate', notify);
	},

	'wrap:applyParams'(origFn, params) {
		this.requestReload();

		return origFn(params);
	},

	'after:onBusMessage'(msg) {
		if (msg.type === 'CLIENT_WEBSOCKET_STATUS_CHANGE' && msg.ready) {
			this.requestReload();
		}

		if (msg.type === 'CALLBACK_CASE_CHANGED') {
			Utils.dedupeCalls(this, 'update-callback-stats', 1000, () => this.reloadCallbackStats());
		}

		if (msg.type == 'SMS_MESSAGE_SENT' || msg.type === 'SMS_MESSAGE_RECEIVED' || msg.type === 'SMS_MESSAGE_READ') {
			Utils.dedupeCalls(this, 'update-sms-stats', 1000, () => this.reloadSmsStats());
		}

		if (msg.type == 'SWITCH_TO_CALL_PANEL') {
			Application.route({
				paramsFn: params => {
					params.set('tab', 'call');
					return params;
				},
			});
		}
	},
});

// }}}
// {{{ Office.AgentSubscriptionWarningDialog

GW.define('Office.AgentSubscriptionWarningDialog', 'Main.Dialog', {
	title: _('Stále jste přihlášeni ve frontách'),
	queues: [],

	'after:initComponent'() {
		this.promise = Utils.makeCompleter();

		this.bodyEl.gwReplaceChildren([{
			nodeName: 'p',
			children: [_('Jste přihlášeni v těchto forntách') + ': ', {
				nodeName: 'strong',
				textContent: this.queues.join(', '),
			}],
		}, {
			nodeName: 'p',
			children: [
				{ nodeName: 'br' }, 
				_('Chcete se z těchto front odhlásit nebo v nich po odhlášení z aplikace zůstat?')
			],
		}]);

		this.footerEl.gwReplaceChildren([{
			nodeName: 'button',
			className: 'secondary',
			textContent: _('Zůstat ve frontách'),
			'on:click': ev => {
				this.promise.resolve('stay');
				this.destroy();
			},
		}, {
			nodeName: 'button',
			className: 'error',
			textContent: _('Odhlásit z front'),
			'on:click': ev => {
				this.promise.resolve('unsub');
				this.destroy();
			},
		}]);
	},

	'before:destroy'() {
		this.promise.resolve('cancel');
	},
});

// }}}

// Agent panel routes:

Application.logoutChecks.push(async function() {
	let exten = Application.session.user.extension;
	if (!exten) {
		return;
	}

	let my_queues = Office.QueueManager.getSubscribedQueues();
	if (my_queues.length > 0) {
		/*
		 * Show warning dialog if user is still subscribed to some queues
		 * on logout.
		 */
		let dlg = new Office.AgentSubscriptionWarningDialog({
			queues: my_queues.map(q => q.name),
		});

		let action = await dlg.promise;
		if (action == 'cancel') {
			return 'cancel';
		} else if (action == 'unsub') {
			await Office.QueueManager.leaveAllQueues(exten);
		}
	}
});

Application.watchMessages(function(msg) {
	if (msg.type == 'CALL_MISSED') {
		let contact = msg.caller || _('anonym');
		if (msg.contact) {
			contact = [msg.contact.name, msg.contact.company].filter(v => v).join(', ');
		}

		Application.desktopNotification({
			title: document.title,
			text: _('Zmeškaný hovor ve frontě {queue} od {contact}')
				.replace('{queue}', msg.queue)
				.replace('{contact}', contact),
			role: 'missed-call',
		});
	}
});

Application.addRoutes([{
	group: 'auth',
	module: 'agent',
	path: APP_BASE + 'agent',
	async handler({params}) {
		let c = Application.show({
			id: 'agent.main',
			xtype: 'Office.AgentPanel',
		});

		c.applyParams(params);
	}
}]);

Application.registerModule({
	id: 'agent',
	title: _('Agent panel'),
	tagline: _('Agentské pracoviště kontaktního centra'),
	icon: 'headphones',
	href: APP_BASE + 'agent',
});
